/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `AWSDate` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 Date](https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates) string. In other words, this scalar type accepts date strings of the form `YYYY-MM-DD`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-05-01**" and "**-9999-01-01**" are both valid dates.  This scalar type can also accept an optional [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators). For example, "**1970-01-01**", "**1970-01-01Z**", "**1970-01-01-07:00**" and "**1970-01-01+05:30**" are all valid dates. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDate: { input: string; output: string; }
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: { input: string; output: string; }
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: { input: string; output: string; }
  /** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
  AWSJSON: { input: string; output: string; }
};

export type AbLinePoint = {
  __typename?: 'ABLinePoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type AbLinePointInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type AbLinesEquationGrid = {
  __typename?: 'ABLinesEquationGrid';
  applicationLength?: Maybe<Scalars['Float']['output']>;
  headlandBuffer?: Maybe<Scalars['Float']['output']>;
  pathMapUuid?: Maybe<Scalars['ID']['output']>;
  pointA?: Maybe<AbLinePoint>;
  pointB?: Maybe<AbLinePoint>;
  sectionWidth?: Maybe<Scalars['Float']['output']>;
  turnRadius?: Maybe<Scalars['Float']['output']>;
  workingWidth?: Maybe<Scalars['Float']['output']>;
};

/**   AB seed: provide EITHER pathMapUuid OR (pointA + pointB), not both. */
export type AbLinesEquationGridInput = {
  applicationLength: Scalars['Float']['input'];
  headlandBuffer: Scalars['Float']['input'];
  pathMapUuid?: InputMaybe<Scalars['ID']['input']>;
  pointA?: InputMaybe<AbLinePointInput>;
  pointB?: InputMaybe<AbLinePointInput>;
  sectionWidth: Scalars['Float']['input'];
  turnRadius?: InputMaybe<Scalars['Float']['input']>;
  workingWidth: Scalars['Float']['input'];
};

export type ActivateCortevaPlanetDataInput = {
  dateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  fieldUuid: Scalars['ID']['input'];
};

export type ActiveIngredientJohnDeere = {
  __typename?: 'ActiveIngredientJohnDeere';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActivityTypeCnh = {
  __typename?: 'ActivityTypeCNH';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AddNoteCommentInput = {
  createdDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  fieldUuid: Scalars['ID']['input'];
  noteUuid: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type AddNoteCommentsInput = {
  comments?: InputMaybe<Array<InputMaybe<AddNoteCommentInput>>>;
};

export type AddVectorAnalysisMapToShoppingCartInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type Agrirouter = {
  __typename?: 'Agrirouter';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  hasOnboardingData?: Maybe<Scalars['Boolean']['output']>;
};

export enum AgrochemicalAnalysisType {
  Abdtpa = 'ABDTPA',
  AmmoniumAcetate = 'AmmoniumAcetate',
  Bray1 = 'Bray1',
  Bray2 = 'Bray2',
  CaCl2 = 'CaCl2',
  Colwell = 'Colwell',
  Combustion = 'Combustion',
  Dtpa = 'DTPA',
  Ec = 'EC',
  EgnerRiehm = 'EgnerRiehm',
  GrainSampling = 'GrainSampling',
  HotWater = 'HotWater',
  LossOnIgnition = 'LossOnIgnition',
  ManureSampling = 'ManureSampling',
  Mehlich1 = 'Mehlich1',
  Mehlich3 = 'Mehlich3',
  MonocalciumPhosphate = 'MonocalciumPhosphate',
  Morgan = 'Morgan',
  Olsen = 'Olsen',
  PlantPetioleSap = 'PlantPetioleSap',
  PlantScouting = 'PlantScouting',
  PlantScoutingPhoto = 'PlantScoutingPhoto',
  PlantTissueLeaf = 'PlantTissueLeaf',
  PlantTissueSampling = 'PlantTissueSampling',
  SoilCarbonBaseline = 'SoilCarbonBaseline',
  SoilMoistureSampling = 'SoilMoistureSampling',
  SoilNutrientSampling = 'SoilNutrientSampling',
  SoilProfileNitrate = 'SoilProfileNitrate',
  SoilTextureSampling = 'SoilTextureSampling',
  WalkleyBlack = 'WalkleyBlack',
  WaterSamplingIrrigation = 'WaterSamplingIrrigation',
  WeedMappingScouting = 'WeedMappingScouting'
}

export enum AgronomicRule {
  FieldPotential = 'FIELD_POTENTIAL',
  Fungicide = 'FUNGICIDE',
  Nitrogen = 'NITROGEN',
  Sample = 'SAMPLE'
}

export enum AnalysisMapStatus {
  Empty = 'EMPTY',
  Error = 'ERROR',
  Executed = 'EXECUTED',
  Saved = 'SAVED'
}

export enum AnalysisMapType {
  AsApplied = 'AS_APPLIED',
  Drawn = 'DRAWN',
  Equation = 'EQUATION',
  External = 'EXTERNAL',
  Grid = 'GRID',
  Multilayers = 'MULTILAYERS',
  Ramap = 'RAMAP',
  Satellite = 'SATELLITE',
  Soil = 'SOIL',
  Topography = 'TOPOGRAPHY',
  Yield = 'YIELD',
  ZoneOperations = 'ZONE_OPERATIONS'
}

export type AnalysisParameters = {
  __typename?: 'AnalysisParameters';
  asAppliedAttribute?: Maybe<Scalars['String']['output']>;
  dataClassificationType?: Maybe<DataClassificationType>;
  index?: Maybe<Index>;
  numberOfZones?: Maybe<Scalars['Int']['output']>;
  pixelSize?: Maybe<Scalars['Int']['output']>;
  polygonMinArea?: Maybe<Scalars['Float']['output']>;
  soilAttribute?: Maybe<Scalars['String']['output']>;
  topographyAttribute?: Maybe<TopographyAttribute>;
  yieldAttribute?: Maybe<Scalars['String']['output']>;
  zonesOperation?: Maybe<ZonesOperationType>;
};

export type ArcGis = {
  __typename?: 'ArcGIS';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum AreaUnit {
  Acres = 'ACRES',
  Hectares = 'HECTARES',
  SquareMeters = 'SQUARE_METERS'
}

export type AsAppliedDataset = {
  __typename?: 'AsAppliedDataset';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate: Scalars['AWSDateTime']['output'];
  cropName?: Maybe<Scalars['String']['output']>;
  cropToken?: Maybe<Scalars['String']['output']>;
  fieldCoverage?: Maybe<Scalars['Float']['output']>;
  fieldCoveredArea?: Maybe<Scalars['Float']['output']>;
  fieldUuid: Scalars['ID']['output'];
  fullAttributes?: Maybe<Array<Maybe<FullAttribute>>>;
  geoJsonUrl?: Maybe<Scalars['String']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  geometryType?: Maybe<GeometryType>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  operationFileDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationId?: Maybe<Scalars['String']['output']>;
  operationStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationType?: Maybe<OperationType>;
  originDataUrl?: Maybe<Scalars['String']['output']>;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<DatasetAttributeStatistics>>>;
  status: DatasetStatus;
  totalCoveredArea?: Maybe<Scalars['Float']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  usedMachines?: Maybe<Array<Maybe<Machine>>>;
  uuid: Scalars['ID']['output'];
};


export type AsAppliedDatasetFieldCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type AsAppliedDatasetGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AsAppliedDatasetOriginDataUrlArgs = {
  format?: InputMaybe<GeoFormat>;
};


export type AsAppliedDatasetSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type AsAppliedDatasetSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};


export type AsAppliedDatasetTotalCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type AsAppliedDatasetFilter = {
  asAppliedDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
};

export enum AssemblyStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AssociatedFullAttribute = {
  __typename?: 'AssociatedFullAttribute';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  humanReadableName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalText?: Maybe<Scalars['String']['output']>;
  samples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unitKey?: Maybe<AttributeUnit>;
  unitValue?: Maybe<Scalars['String']['output']>;
};

export type AssociatedFullAttributeInput = {
  columnIndex?: InputMaybe<Scalars['Int']['input']>;
  humanReadableName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalText?: InputMaybe<Scalars['String']['input']>;
  unitKey?: InputMaybe<AttributeUnit>;
  unitValue?: InputMaybe<Scalars['String']['input']>;
};

export enum AttributeUnit {
  Ac = 'AC',
  AcPerHr = 'AC_per_HR',
  Arcdeg = 'ARCDEG',
  BalePerAc = 'BALE_per_AC',
  BalePerHa = 'BALE_per_HA',
  BalePerM2 = 'BALE_per_M2',
  Bar = 'BAR',
  BqPerKg = 'BQ_per_KG',
  Bu = 'BU',
  BuPerAc = 'BU_per_AC',
  C = 'C',
  Cm = 'CM',
  Count = 'COUNT',
  Cwt = 'CWT',
  CwtPerAc = 'CWT_per_AC',
  Dg = 'DG',
  DgPerHa = 'DG_per_HA',
  DgPerMm2 = 'DG_per_MM2',
  DlPerHa = 'DL_per_HA',
  EurPerAc = 'EUR_per_AC',
  EurPerHa = 'EUR_per_HA',
  F = 'F',
  FlozPerAc = 'FLOZ_per_AC',
  Ft = 'FT',
  Ft2 = 'FT2',
  FtPerHr = 'FT_per_HR',
  G = 'G',
  Gal = 'GAL',
  GalPerAc = 'GAL_per_AC',
  GPerHa = 'G_per_HA',
  GPerM2 = 'G_per_M2',
  Ha = 'HA',
  Hr = 'HR',
  In = 'IN',
  K = 'K',
  Kg = 'KG',
  KgPerCm2 = 'KG_per_CM2',
  KgPerHa = 'KG_per_HA',
  KgPerL = 'KG_per_L',
  KgPerM2 = 'KG_per_M2',
  KgPerM3 = 'KG_per_M3',
  KgPerSec = 'KG_per_SEC',
  KlPerHa = 'KL_per_HA',
  Km = 'KM',
  KmPerHr = 'KM_per_HR',
  Kpa = 'KPA',
  L = 'L',
  Lb = 'LB',
  Lbf = 'LBF',
  LbPerAc = 'LB_per_AC',
  LbPerBu = 'LB_per_BU',
  LbPerFt2 = 'LB_per_FT2',
  LbPerHr = 'LB_per_HR',
  LPerHa = 'L_per_HA',
  LPerHr = 'L_per_HR',
  LPerM2 = 'L_per_M2',
  M = 'M',
  M2 = 'M2',
  M3PerHa = 'M3_per_HA',
  MeqPer_100G = 'MEQ_per_100G',
  Mg = 'MG',
  MgPer_100G = 'MG_per_100G',
  MgPerHa = 'MG_per_HA',
  MgPerKg = 'MG_per_KG',
  MgPerL = 'MG_per_L',
  MgPerM2 = 'MG_per_M2',
  MgPerSec = 'MG_per_SEC',
  Mi = 'MI',
  MiPerHr = 'MI_per_HR',
  MlPerHa = 'ML_per_HA',
  MlPerM2 = 'ML_per_M2',
  Mm = 'MM',
  MmPerSec = 'MM_per_SEC',
  Ms = 'MS',
  MsPerCm = 'MS_per_CM',
  MsPerM = 'MS_per_M',
  MPerHr = 'M_per_HR',
  MPerSec = 'M_per_SEC',
  N = 'N',
  Nm = 'NM',
  Ozm = 'OZM',
  OzmPerAc = 'OZM_per_AC',
  OzmPerFt2 = 'OZM_per_FT2',
  Pa = 'PA',
  Pct = 'PCT',
  PointsPerSec = 'POINTS_per_SEC',
  Ppm = 'PPM',
  Psi = 'PSI',
  PtPerAc = 'PT_per_AC',
  QtPerAc = 'QT_per_AC',
  Rpm = 'RPM',
  Sec = 'SEC',
  SeedsPerAc = 'SEEDS_per_AC',
  SeedsPerFt2 = 'SEEDS_per_FT2',
  SeedsPerHa = 'SEEDS_per_HA',
  SeedsPerM2 = 'SEEDS_per_M2',
  T = 'T',
  ThndseedsPerAc = 'THNDSEEDS_per_AC',
  ThndseedsPerHa = 'THNDSEEDS_per_HA',
  Ton = 'TON',
  TonPerAc = 'TON_per_AC',
  TPerAc = 'T_per_AC',
  TPerHa = 'T_per_HA',
  UlPerHa = 'UL_per_HA',
  Um = 'UM',
  Unitless = 'UNITLESS',
  UsdPerAc = 'USD_per_AC',
  UsdPerHa = 'USD_per_HA',
  Yd = 'YD',
  PerPct = 'per_PCT'
}

export type BatchDeleteFarmInput = {
  farmUuids: Array<InputMaybe<Scalars['ID']['input']>>;
  userEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BatchShareFarmInput = {
  allFarms?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BatchUserOrganizationInput = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationUuid: Scalars['ID']['input'];
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BoundaryCnh = {
  __typename?: 'BoundaryCNH';
  area?: Maybe<Scalars['Float']['output']>;
  boundaryType?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  coordinates?: Maybe<Array<Maybe<CoordinateBoundaryCnh>>>;
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type BoundaryFilterCnh = {
  boundaryId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};

export type BoundaryInfoCnh = {
  __typename?: 'BoundaryInfoCNH';
  area: Scalars['Float']['output'];
  boundaryType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BoundaryInfoFilterCnh = {
  companyId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
};

export enum BufferSize {
  MinusOnePixel = 'MinusOnePixel',
  MinusTwoPixels = 'MinusTwoPixels',
  NoBuffer = 'NoBuffer',
  PlusOnePixel = 'PlusOnePixel',
  PlusTwoPixels = 'PlusTwoPixels'
}

export type BulkFieldLabels = {
  fields?: InputMaybe<Array<InputMaybe<FieldLabels>>>;
};

export type Cnh = {
  __typename?: 'CNH';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CalibrateDatasetAction = {
  __typename?: 'CalibrateDatasetAction';
  calibrationAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  conditionAvgTotalCalibration?: Maybe<Array<Maybe<ConditionAvgTotalCalibration>>>;
  conditionMinMaxCalibration?: Maybe<Array<Maybe<ConditionMinMaxCalibration>>>;
  conditionPathwiseCalibration?: Maybe<ConditionPathwiseCalibration>;
  smoothWindowSize?: Maybe<Scalars['Int']['output']>;
};

export type CalibrateDatasetActionInput = {
  calibrationAttributes: Array<InputMaybe<Scalars['String']['input']>>;
  conditionAvgTotalCalibration?: InputMaybe<Array<InputMaybe<ConditionAvgTotalCalibrationInput>>>;
  conditionMinMaxCalibration?: InputMaybe<Array<InputMaybe<ConditionMinMaxCalibrationInput>>>;
  conditionPathwiseCalibration?: InputMaybe<ConditionPathwiseCalibrationInput>;
  smoothWindowSize?: InputMaybe<Scalars['Int']['input']>;
};

export type CalibrateYieldDatasetInput = {
  actions?: InputMaybe<DatasetActionsInput>;
  fieldUuid: Scalars['ID']['input'];
  yieldDatasetUuid: Scalars['ID']['input'];
};

export type CarrierTankMixJohnDeere = {
  __typename?: 'CarrierTankMixJohnDeere';
  chemical: ChemicalTankMixJohnDeere;
  rate: RateValueJohnDeere;
};

export type Centroid = {
  __typename?: 'Centroid';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CentroidInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CheckCortevaPreBillingPlanetDataInput = {
  dateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  dateTo?: InputMaybe<Scalars['AWSDate']['input']>;
  fieldUuid: Scalars['ID']['input'];
};

export type ChemicalCnh = {
  __typename?: 'ChemicalCNH';
  activeIngredientPercent: Scalars['String']['output'];
  categoryId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  fieldReentryHours: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRestrictedUse: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preharvestHours: Scalars['String']['output'];
  productFormId: Scalars['String']['output'];
  unitCost: Scalars['String']['output'];
};

export type ChemicalTankMixJohnDeere = {
  __typename?: 'ChemicalTankMixJohnDeere';
  archived: Scalars['Boolean']['output'];
  carrier: Scalars['Boolean']['output'];
  carrierId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materialClassification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referenceGuid: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  restrictedUse: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type CleanDatasetAction = {
  __typename?: 'CleanDatasetAction';
  conditionAutoClean?: Maybe<ConditionAutoClean>;
  conditionMinMaxClean?: Maybe<Array<Maybe<ConditionMinMaxClean>>>;
  conditionUsda?: Maybe<ConditionUsda>;
};

export type CleanDatasetActionInput = {
  conditionAutoClean?: InputMaybe<ConditionAutoCleanInput>;
  conditionMinMaxClean?: InputMaybe<Array<InputMaybe<ConditionMinMaxCleanInput>>>;
  conditionUsda?: InputMaybe<ConditionUsdaInput>;
};

export type Climate = {
  __typename?: 'Climate';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  fieldHierarchyMapping?: Maybe<FieldHierarchyMappingClimate>;
  users?: Maybe<Array<Maybe<ClimateUser>>>;
};

export type ClimateUser = {
  __typename?: 'ClimateUser';
  email?: Maybe<Scalars['String']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
};

export type Color = {
  __typename?: 'Color';
  hexCode: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type ColorInput = {
  hexCode: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type ColorSchema = {
  __typename?: 'ColorSchema';
  colors?: Maybe<Array<Maybe<Color>>>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ColorSchemaInput = {
  colors?: InputMaybe<Array<InputMaybe<ColorInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ColorSchemasInput = {
  schemas?: InputMaybe<Array<InputMaybe<ColorSchemaInput>>>;
};

export type Comment = {
  __typename?: 'Comment';
  createdDate: Scalars['AWSDateTime']['output'];
  fieldUuid: Scalars['ID']['output'];
  noteUuid: Scalars['ID']['output'];
  photos?: Maybe<Array<Maybe<Photo>>>;
  text?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type CompanyCnh = {
  __typename?: 'CompanyCNH';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompleteSamplingPlan = {
  __typename?: 'CompleteSamplingPlan';
  fieldUuid: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type CompleteSamplingPlanInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type ComponentDryBlendJohnDeere = {
  __typename?: 'ComponentDryBlendJohnDeere';
  product: ProductDryBlendJohnDeere;
  rate: RateValueJohnDeere;
};

export type ComponentTankMixJohnDeere = {
  __typename?: 'ComponentTankMixJohnDeere';
  chemical: ChemicalTankMixJohnDeere;
  rate: RateValueJohnDeere;
};

export type ConditionAutoClean = {
  __typename?: 'ConditionAutoClean';
  excludedAttributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  targetAttribute?: Maybe<Scalars['String']['output']>;
};

export type ConditionAutoCleanInput = {
  excludedAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetAttribute: Scalars['String']['input'];
};

export type ConditionAvgTotalCalibration = {
  __typename?: 'ConditionAvgTotalCalibration';
  average?: Maybe<Scalars['Float']['output']>;
  calibrationAttribute?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type ConditionAvgTotalCalibrationInput = {
  average?: InputMaybe<Scalars['Float']['input']>;
  calibrationAttribute: Scalars['String']['input'];
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type ConditionMinMaxCalibration = {
  __typename?: 'ConditionMinMaxCalibration';
  calibrationAttribute?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  maxIncluded?: Maybe<Scalars['Boolean']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minIncluded?: Maybe<Scalars['Boolean']['output']>;
};

export type ConditionMinMaxCalibrationInput = {
  calibrationAttribute: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  maxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionMinMaxClean = {
  __typename?: 'ConditionMinMaxClean';
  cleanAttribute?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  stdNumber?: Maybe<Scalars['Int']['output']>;
};

export type ConditionMinMaxCleanInput = {
  cleanAttribute: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  stdNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type ConditionPathwiseCalibration = {
  __typename?: 'ConditionPathwiseCalibration';
  calibrationBasis?: Maybe<Scalars['String']['output']>;
  maxHomogeneityRegion?: Maybe<Scalars['Boolean']['output']>;
  syntheticMachinePath?: Maybe<Scalars['Boolean']['output']>;
};

export type ConditionPathwiseCalibrationInput = {
  calibrationBasis: Scalars['String']['input'];
  maxHomogeneityRegion?: InputMaybe<Scalars['Boolean']['input']>;
  syntheticMachinePath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConditionUsda = {
  __typename?: 'ConditionUsda';
  crop?: Maybe<Scalars['String']['output']>;
  delayUnit?: Maybe<AttributeUnit>;
  distanceAttribute?: Maybe<Scalars['String']['output']>;
  endPassDelay?: Maybe<Scalars['Int']['output']>;
  flowDelay?: Maybe<Scalars['Int']['output']>;
  moistureAttribute?: Maybe<Scalars['String']['output']>;
  moistureDelay?: Maybe<Scalars['Int']['output']>;
  moistureMin?: Maybe<Scalars['Float']['output']>;
  removeOverlappingTolerance?: Maybe<Scalars['Float']['output']>;
  startPassDelay?: Maybe<Scalars['Int']['output']>;
  stdNum?: Maybe<Scalars['Int']['output']>;
  swathWidthAttribute?: Maybe<Scalars['String']['output']>;
  velocityAttribute?: Maybe<Scalars['String']['output']>;
  velocityMax?: Maybe<Scalars['Float']['output']>;
  velocityMin?: Maybe<Scalars['Float']['output']>;
  velocityUnit?: Maybe<AttributeUnit>;
  yieldAttribute?: Maybe<Scalars['String']['output']>;
  yieldMax?: Maybe<Scalars['Float']['output']>;
  yieldMin?: Maybe<Scalars['Float']['output']>;
  yieldUnit?: Maybe<AttributeUnit>;
};

export type ConditionUsdaInput = {
  crop: Scalars['String']['input'];
  delayUnit?: InputMaybe<AttributeUnit>;
  distanceAttribute?: InputMaybe<Scalars['String']['input']>;
  endPassDelay?: InputMaybe<Scalars['Int']['input']>;
  flowDelay?: InputMaybe<Scalars['Int']['input']>;
  moistureAttribute?: InputMaybe<Scalars['String']['input']>;
  moistureDelay?: InputMaybe<Scalars['Int']['input']>;
  moistureMin?: InputMaybe<Scalars['Float']['input']>;
  removeOverlappingTolerance?: InputMaybe<Scalars['Float']['input']>;
  startPassDelay?: InputMaybe<Scalars['Int']['input']>;
  stdNum?: InputMaybe<Scalars['Int']['input']>;
  swathWidthAttribute?: InputMaybe<Scalars['String']['input']>;
  velocityAttribute?: InputMaybe<Scalars['String']['input']>;
  velocityMax?: InputMaybe<Scalars['Float']['input']>;
  velocityMin?: InputMaybe<Scalars['Float']['input']>;
  velocityUnit?: InputMaybe<AttributeUnit>;
  yieldAttribute: Scalars['String']['input'];
  yieldMax?: InputMaybe<Scalars['Float']['input']>;
  yieldMin?: InputMaybe<Scalars['Float']['input']>;
  yieldUnit?: InputMaybe<AttributeUnit>;
};

export enum ConfigurationProfile {
  Country = 'COUNTRY',
  WebFeatureFlag = 'WEB_FEATURE_FLAG'
}

export type ConfirmFileUpload = {
  __typename?: 'ConfirmFileUpload';
  result?: Maybe<Array<ImportDataObject>>;
  s3Key: Scalars['String']['output'];
  s3Url: Scalars['String']['output'];
};

export type ConfirmFileUploadFieldInput = {
  associatedSamplingPlan?: InputMaybe<ConfirmFileUploadSamplingPlanInput>;
  farmUuid: Scalars['ID']['input'];
  labels?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  uuid: Scalars['ID']['input'];
};

export type ConfirmFileUploadInput = {
  associatedFields?: InputMaybe<Array<ConfirmFileUploadFieldInput>>;
  associatedFullAttributes?: InputMaybe<Array<AssociatedFullAttributeInput>>;
  headerDetection: HeaderDetectionInput;
  metadataFields?: InputMaybe<Array<MetadataFieldInput>>;
  s3Key: Scalars['String']['input'];
  s3Url: Scalars['String']['input'];
};

export type ConfirmFileUploadSamplingPlanInput = {
  analysisDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export enum ContextEventStatus {
  Cancelled = 'Cancelled',
  CollectedFromJohnDeere = 'CollectedFromJohnDeere',
  Created = 'Created',
  Done = 'Done',
  Error = 'Error',
  FileSaved = 'FileSaved',
  GenericSatelliteImageArchiveReady = 'GenericSatelliteImageArchiveReady',
  GeoDataSaved = 'GeoDataSaved',
  Ignored = 'Ignored',
  InProgress = 'InProgress',
  Linked = 'Linked',
  MetaDataSaved = 'MetaDataSaved',
  NotDelivered = 'NotDelivered',
  Ordered = 'Ordered',
  Parsed = 'Parsed',
  PlanetMaskArchiveReady = 'PlanetMaskArchiveReady',
  PlanetSatelliteImageArchiveReady = 'PlanetSatelliteImageArchiveReady',
  PublishToJohnDeere = 'PublishToJohnDeere',
  PublishToMapEngine = 'PublishToMapEngine',
  SendToCollectContext = 'SendToCollectContext',
  SendToProcessElevation = 'SendToProcessElevation',
  Start = 'Start',
  StatisticsCalculated = 'StatisticsCalculated',
  Unknown = 'UNKNOWN',
  Uploaded = 'Uploaded',
  Validated = 'Validated',
  Warning = 'Warning'
}

export enum ContextMessageKey {
  AllPixelsAreCloudyOrCorrupted = 'AllPixelsAreCloudyOrCorrupted',
  DatasetContainsCorruptedData = 'DatasetContainsCorruptedData',
  DatasetContainsCorruptedGeometry = 'DatasetContainsCorruptedGeometry',
  DatasetIsEmpty = 'DatasetIsEmpty',
  DatasetWasAlreadyMappedToField = 'DatasetWasAlreadyMappedToField',
  DatasetWasNotMappedToField = 'DatasetWasNotMappedToField',
  DatasetWasUploadedAutomatically = 'DatasetWasUploadedAutomatically',
  DatasetWasUploadedManually = 'DatasetWasUploadedManually',
  ElevationDataDoesNotExist = 'ElevationDataDoesNotExist',
  EquationExecutionError = 'EquationExecutionError',
  FarmHasNoFields = 'FarmHasNoFields',
  FieldDoesNotExist = 'FieldDoesNotExist',
  FieldRegistrationWasNotFullyCompleted = 'FieldRegistrationWasNotFullyCompleted',
  FileIsNotReadable = 'FileIsNotReadable',
  FileIsNotZipArchive = 'FileIsNotZipArchive',
  InfrastructureError = 'InfrastructureError',
  MetadataJsonIsCorrupted = 'MetadataJsonIsCorrupted',
  MetadataJsonIsNotUtf8Compatible = 'MetadataJsonIsNotUtf8Compatible',
  PrecisionError = 'PrecisionError',
  StatisticsWasNotCalculated = 'StatisticsWasNotCalculated',
  Unknown = 'Unknown',
  UnprocessedAttribute = 'UnprocessedAttribute',
  UnsupportedDateFormat = 'UnsupportedDateFormat'
}

export type CoordinateBoundaryCnh = {
  __typename?: 'CoordinateBoundaryCNH';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CortevaZonesMapAsync = {
  __typename?: 'CortevaZonesMapAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  usedSatelliteImagesNumber?: Maybe<Scalars['Int']['output']>;
  usedYieldDatasetsNumber?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum Country {
  Abw = 'ABW',
  Afg = 'AFG',
  Ago = 'AGO',
  Aia = 'AIA',
  Ala = 'ALA',
  Alb = 'ALB',
  And = 'AND',
  Are = 'ARE',
  Arg = 'ARG',
  Arm = 'ARM',
  Asm = 'ASM',
  Ata = 'ATA',
  Atf = 'ATF',
  Atg = 'ATG',
  Aus = 'AUS',
  Aut = 'AUT',
  Aze = 'AZE',
  Bdi = 'BDI',
  Bel = 'BEL',
  Ben = 'BEN',
  Bes = 'BES',
  Bfa = 'BFA',
  Bgd = 'BGD',
  Bgr = 'BGR',
  Bhr = 'BHR',
  Bhs = 'BHS',
  Bih = 'BIH',
  Blm = 'BLM',
  Blr = 'BLR',
  Blz = 'BLZ',
  Bmu = 'BMU',
  Bol = 'BOL',
  Bra = 'BRA',
  Brb = 'BRB',
  Brn = 'BRN',
  Btn = 'BTN',
  Bvt = 'BVT',
  Bwa = 'BWA',
  Caf = 'CAF',
  Can = 'CAN',
  Cck = 'CCK',
  Che = 'CHE',
  Chl = 'CHL',
  Chn = 'CHN',
  Civ = 'CIV',
  Cmr = 'CMR',
  Cod = 'COD',
  Cog = 'COG',
  Cok = 'COK',
  Col = 'COL',
  Com = 'COM',
  Cpv = 'CPV',
  Cri = 'CRI',
  Cub = 'CUB',
  Cuw = 'CUW',
  Cxr = 'CXR',
  Cym = 'CYM',
  Cyp = 'CYP',
  Cze = 'CZE',
  Deu = 'DEU',
  Dji = 'DJI',
  Dma = 'DMA',
  Dnk = 'DNK',
  Dom = 'DOM',
  Dza = 'DZA',
  Ecu = 'ECU',
  Egy = 'EGY',
  Eri = 'ERI',
  Esh = 'ESH',
  Esp = 'ESP',
  Est = 'EST',
  Eth = 'ETH',
  Fin = 'FIN',
  Fji = 'FJI',
  Flk = 'FLK',
  Fra = 'FRA',
  Fro = 'FRO',
  Fsm = 'FSM',
  Gab = 'GAB',
  Gbr = 'GBR',
  Geo = 'GEO',
  Ggy = 'GGY',
  Gha = 'GHA',
  Gib = 'GIB',
  Gin = 'GIN',
  Glp = 'GLP',
  Gmb = 'GMB',
  Gnb = 'GNB',
  Gnq = 'GNQ',
  Grc = 'GRC',
  Grd = 'GRD',
  Grl = 'GRL',
  Gtm = 'GTM',
  Guf = 'GUF',
  Gum = 'GUM',
  Guy = 'GUY',
  Hkg = 'HKG',
  Hmd = 'HMD',
  Hnd = 'HND',
  Hrv = 'HRV',
  Hti = 'HTI',
  Hun = 'HUN',
  Idn = 'IDN',
  Imn = 'IMN',
  Ind = 'IND',
  Iot = 'IOT',
  Irl = 'IRL',
  Irn = 'IRN',
  Irq = 'IRQ',
  Isl = 'ISL',
  Isr = 'ISR',
  Ita = 'ITA',
  Jam = 'JAM',
  Jey = 'JEY',
  Jor = 'JOR',
  Jpn = 'JPN',
  Kaz = 'KAZ',
  Ken = 'KEN',
  Kgz = 'KGZ',
  Khm = 'KHM',
  Kir = 'KIR',
  Kna = 'KNA',
  Kor = 'KOR',
  Kwt = 'KWT',
  Lao = 'LAO',
  Lbn = 'LBN',
  Lbr = 'LBR',
  Lby = 'LBY',
  Lca = 'LCA',
  Lie = 'LIE',
  Lka = 'LKA',
  Lso = 'LSO',
  Ltu = 'LTU',
  Lux = 'LUX',
  Lva = 'LVA',
  Mac = 'MAC',
  Maf = 'MAF',
  Mar = 'MAR',
  Mco = 'MCO',
  Mda = 'MDA',
  Mdg = 'MDG',
  Mdv = 'MDV',
  Mex = 'MEX',
  Mhl = 'MHL',
  Mkd = 'MKD',
  Mli = 'MLI',
  Mlt = 'MLT',
  Mmr = 'MMR',
  Mne = 'MNE',
  Mng = 'MNG',
  Mnp = 'MNP',
  Moz = 'MOZ',
  Mrt = 'MRT',
  Msr = 'MSR',
  Mtq = 'MTQ',
  Mus = 'MUS',
  Mwi = 'MWI',
  Mys = 'MYS',
  Myt = 'MYT',
  Nam = 'NAM',
  Ncl = 'NCL',
  Ner = 'NER',
  Nfk = 'NFK',
  Nga = 'NGA',
  Nic = 'NIC',
  Niu = 'NIU',
  Nld = 'NLD',
  Nor = 'NOR',
  Npl = 'NPL',
  Nru = 'NRU',
  Nzl = 'NZL',
  Omn = 'OMN',
  Pak = 'PAK',
  Pan = 'PAN',
  Pcn = 'PCN',
  Per = 'PER',
  Phl = 'PHL',
  Plw = 'PLW',
  Png = 'PNG',
  Pol = 'POL',
  Pri = 'PRI',
  Prk = 'PRK',
  Prt = 'PRT',
  Pry = 'PRY',
  Pse = 'PSE',
  Pyf = 'PYF',
  Qat = 'QAT',
  Reu = 'REU',
  Rou = 'ROU',
  Rus = 'RUS',
  Rwa = 'RWA',
  Sau = 'SAU',
  Sdn = 'SDN',
  Sen = 'SEN',
  Sgp = 'SGP',
  Sgs = 'SGS',
  Shn = 'SHN',
  Sjm = 'SJM',
  Slb = 'SLB',
  Sle = 'SLE',
  Slv = 'SLV',
  Smr = 'SMR',
  Som = 'SOM',
  Spm = 'SPM',
  Srb = 'SRB',
  Ssd = 'SSD',
  Stp = 'STP',
  Sur = 'SUR',
  Svk = 'SVK',
  Svn = 'SVN',
  Swe = 'SWE',
  Swz = 'SWZ',
  Sxm = 'SXM',
  Syc = 'SYC',
  Syr = 'SYR',
  Tca = 'TCA',
  Tcd = 'TCD',
  Tgo = 'TGO',
  Tha = 'THA',
  Tjk = 'TJK',
  Tkl = 'TKL',
  Tkm = 'TKM',
  Tls = 'TLS',
  Ton = 'TON',
  Tto = 'TTO',
  Tun = 'TUN',
  Tur = 'TUR',
  Tuv = 'TUV',
  Twn = 'TWN',
  Tza = 'TZA',
  Uga = 'UGA',
  Ukr = 'UKR',
  Umi = 'UMI',
  Ury = 'URY',
  Usa = 'USA',
  Uzb = 'UZB',
  Vat = 'VAT',
  Vct = 'VCT',
  Ven = 'VEN',
  Vgb = 'VGB',
  Vir = 'VIR',
  Vnm = 'VNM',
  Vut = 'VUT',
  Wlf = 'WLF',
  Wsm = 'WSM',
  Xkx = 'XKX',
  Yem = 'YEM',
  Zaf = 'ZAF',
  Zmb = 'ZMB',
  Zwe = 'ZWE'
}

export type CreateFarmInput = {
  externalKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFieldOperationSubscriptionJohnDeereInput = {
  fieldOperationTypes?: InputMaybe<Array<InputMaybe<FieldOperationJohnDeereTypes>>>;
  orgIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type CreateHarvestPlantingApplicationSubscriptionClimateInput = {
  dataTypes: Array<InputMaybe<DataTypeClimate>>;
  frequency: Scalars['Int']['input'];
  users: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CreateOperationSubscriptionCnhInput = {
  companyId: Scalars['ID']['input'];
};

export enum CropEnum {
  Barley = 'BARLEY',
  Canola = 'CANOLA',
  Corn = 'CORN',
  CornSilage = 'CORN_SILAGE',
  Cotton = 'COTTON',
  Oats = 'OATS',
  Rapeseed = 'RAPESEED',
  Rice = 'RICE',
  Rye = 'RYE',
  Sorghum = 'SORGHUM',
  Soybeans = 'SOYBEANS',
  Sunflower = 'SUNFLOWER',
  Wheat = 'WHEAT'
}

export type CubeAssemblyInput = {
  asAppliedDatasets?: InputMaybe<Array<DatasetInput>>;
  equationMaps?: InputMaybe<Array<DatasetInput>>;
  fieldUuid: Scalars['ID']['input'];
  satelliteImages?: InputMaybe<Array<DatasetInput>>;
  soilDatasets?: InputMaybe<Array<DatasetInput>>;
  topographyMaps?: InputMaybe<Array<DatasetInput>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  yieldDatasets?: InputMaybe<Array<DatasetInput>>;
  zoneMaps?: InputMaybe<Array<DatasetInput>>;
};

export type CubeAssemblyOutput = {
  __typename?: 'CubeAssemblyOutput';
  fieldUuid: Scalars['ID']['output'];
  s3CubeKey?: Maybe<Scalars['String']['output']>;
  s3MappingKey?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  status: AssemblyStatus;
  uuid: Scalars['ID']['output'];
};

export enum Currency {
  Eur = 'EUR',
  Usd = 'USD'
}

export enum DataClassificationType {
  Deprecated = 'DEPRECATED',
  EqualCount = 'EQUAL_COUNT',
  EqualInterval = 'EQUAL_INTERVAL',
  GeopardAuto = 'GEOPARD_AUTO',
  NaturalBreaks = 'NATURAL_BREAKS',
  SpatiallyLocalized = 'SPATIALLY_LOCALIZED',
  SpatiallyLocalizedBalanced = 'SPATIALLY_LOCALIZED__BALANCED',
  SpatiallyLocalizedSpatial = 'SPATIALLY_LOCALIZED__SPATIAL',
  SpatiallyLocalizedValue = 'SPATIALLY_LOCALIZED__VALUE'
}

export type DataLayer = {
  __typename?: 'DataLayer';
  asAppliedAttribute?: Maybe<Scalars['String']['output']>;
  asAppliedDataset?: Maybe<AsAppliedDataset>;
  equationMap?: Maybe<EquationMap>;
  factor: Scalars['Float']['output'];
  index?: Maybe<Index>;
  satelliteImages?: Maybe<Array<Maybe<FieldSatelliteImage>>>;
  soilAttribute?: Maybe<Scalars['String']['output']>;
  soilDataset?: Maybe<SoilDataset>;
  topographyAttribute?: Maybe<TopographyAttribute>;
  topographyMap?: Maybe<TopographyMap>;
  yieldAttribute?: Maybe<Scalars['String']['output']>;
  yieldDataset?: Maybe<YieldDataset>;
};

export type DataLayerInput = {
  asAppliedAttribute?: InputMaybe<Scalars['String']['input']>;
  asAppliedDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  equationMapUuid?: InputMaybe<Scalars['ID']['input']>;
  factor: Scalars['Float']['input'];
  index?: InputMaybe<Index>;
  satelliteImageUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  soilAttribute?: InputMaybe<Scalars['String']['input']>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  topographyAttribute?: InputMaybe<TopographyAttribute>;
  topographyMapUuid?: InputMaybe<Scalars['ID']['input']>;
  yieldAttribute?: InputMaybe<Scalars['String']['input']>;
  yieldDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum DataTypeClimate {
  Application = 'APPLICATION',
  Harvest = 'HARVEST',
  Planting = 'PLANTING'
}

export type DataVariable = {
  __typename?: 'DataVariable';
  asAppliedAttribute?: Maybe<Scalars['String']['output']>;
  asAppliedDataset?: Maybe<AsAppliedDataset>;
  equationMap?: Maybe<EquationMap>;
  index?: Maybe<Index>;
  sampleValue?: Maybe<Scalars['Float']['output']>;
  satelliteImages?: Maybe<Array<Maybe<FieldSatelliteImage>>>;
  soilAttribute?: Maybe<Scalars['String']['output']>;
  soilDataset?: Maybe<SoilDataset>;
  statistics?: Maybe<EquationMapStatistics>;
  topographyAttribute?: Maybe<TopographyAttribute>;
  topographyMap?: Maybe<TopographyMap>;
  variable: Scalars['String']['output'];
  vectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  vectorAnalysisMapZoneTypeAttribute?: Maybe<VectorAnalysisMapZoneType>;
  yieldAttribute?: Maybe<Scalars['String']['output']>;
  yieldDataset?: Maybe<YieldDataset>;
};

export type DataVariableInput = {
  asAppliedAttribute?: InputMaybe<Scalars['String']['input']>;
  asAppliedDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  equationMapUuid?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Index>;
  sampleValue?: InputMaybe<Scalars['Float']['input']>;
  satelliteImageUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  soilAttribute?: InputMaybe<Scalars['String']['input']>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  topographyAttribute?: InputMaybe<TopographyAttribute>;
  topographyMapUuid?: InputMaybe<Scalars['ID']['input']>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  variable: Scalars['String']['input'];
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapZoneTypeAttribute?: InputMaybe<VectorAnalysisMapZoneType>;
  yieldAttribute?: InputMaybe<Scalars['String']['input']>;
  yieldDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum DatasetActionEnum {
  Calibrate = 'CALIBRATE',
  Clean = 'CLEAN'
}

export type DatasetActions = {
  __typename?: 'DatasetActions';
  actions?: Maybe<Array<Maybe<DatasetActionEnum>>>;
  calibrateAction?: Maybe<CalibrateDatasetAction>;
  cleanAction?: Maybe<CleanDatasetAction>;
};

export type DatasetActionsInput = {
  actions: Array<InputMaybe<DatasetActionEnum>>;
  calibrateAction?: InputMaybe<CalibrateDatasetActionInput>;
  cleanAction?: InputMaybe<CleanDatasetActionInput>;
};

export type DatasetAttributeStatistics = {
  __typename?: 'DatasetAttributeStatistics';
  attribute?: Maybe<Scalars['String']['output']>;
  avg?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  mdn?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  std?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  uniqueArr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  uniqueCnt?: Maybe<Scalars['Int']['output']>;
  var?: Maybe<Scalars['Float']['output']>;
};

export type DatasetInput = {
  uuid: Scalars['ID']['input'];
};

export enum DatasetStatus {
  Binded = 'BINDED',
  Cleaned = 'CLEANED',
  Invalid = 'INVALID',
  NotDelivered = 'NOT_DELIVERED',
  Ordered = 'ORDERED',
  Processed = 'PROCESSED',
  Published = 'PUBLISHED',
  Uploaded = 'UPLOADED',
  Validated = 'VALIDATED'
}

export type DateTimeFilterInput = {
  after?: InputMaybe<Scalars['AWSDateTime']['input']>;
  before?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DeleteAsAppliedDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteEquationInput = {
  uuid: Scalars['ID']['input'];
};

export type DeleteEquationMapInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteFarmInput = {
  userUuid?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['ID']['input'];
};

export type DeleteFieldInput = {
  farmUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteNoteInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteNotesInput = {
  notes?: InputMaybe<Array<InputMaybe<DeleteNoteInput>>>;
};

export type DeletePhotoInput = {
  commentUuid?: InputMaybe<Scalars['ID']['input']>;
  noteUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeletePhotosInput = {
  photos?: InputMaybe<Array<InputMaybe<DeletePhotoInput>>>;
};

export type DeleteRasterAnalysisMapInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteSamplingPlanInput = {
  fieldUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type DeleteSamplingPlans = {
  __typename?: 'DeleteSamplingPlans';
  deletedNotesCount: Scalars['Int']['output'];
  deletedPathsCount: Scalars['Int']['output'];
  deletedPlansCount: Scalars['Int']['output'];
};

export type DeleteSoilDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteSubscriptionCnhInput = {
  companyId: Scalars['ID']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type DeleteThreeDimensionalMapInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteTopographyDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteTrialInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteUserBatch = {
  __typename?: 'DeleteUserBatch';
  batchUuid: Scalars['ID']['output'];
  results?: Maybe<DeleteUserBatchResults>;
};

export type DeleteUserBatchInput = {
  batchUuid: Scalars['ID']['input'];
};

export type DeleteUserBatchResults = {
  __typename?: 'DeleteUserBatchResults';
  samplingPlan?: Maybe<DeleteSamplingPlans>;
};

export type DeleteVectorAnalysisMapInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DeleteYieldDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type DetailResponseOperationAgrirouter = {
  __typename?: 'DetailResponseOperationAgrirouter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationArcGis = {
  __typename?: 'DetailResponseOperationArcGIS';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationCnh = {
  __typename?: 'DetailResponseOperationCNH';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationClimate = {
  __typename?: 'DetailResponseOperationClimate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationFarmEngage = {
  __typename?: 'DetailResponseOperationFarmEngage';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationJohnDeere = {
  __typename?: 'DetailResponseOperationJohnDeere';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DetailResponseOperationPessl = {
  __typename?: 'DetailResponseOperationPessl';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum DisplayFormat {
  Gfx = 'GFX',
  Trimble = 'TRIMBLE'
}

export type DocumentJohnDeere = {
  __typename?: 'DocumentJohnDeere';
  description: Scalars['String']['output'];
  docType: Scalars['String']['output'];
  erid: Scalars['ID']['output'];
  expirationDate: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  productErid: Scalars['String']['output'];
};

export type DryBlendJohnDeere = {
  __typename?: 'DryBlendJohnDeere';
  archived: Scalars['Boolean']['output'];
  components?: Maybe<Array<Maybe<ComponentDryBlendJohnDeere>>>;
  erid: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  materialClassification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  solutionRate: RateValueJohnDeere;
  targetCrops?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum Environment {
  Dev = 'DEV',
  Prod = 'PROD'
}

export type Equation = {
  __typename?: 'Equation';
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  dataVariables: Array<Maybe<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  equationAsText: Scalars['String']['output'];
  equationResultVariable: Scalars['String']['output'];
  organizationUuid?: Maybe<Scalars['ID']['output']>;
  productUnit?: Maybe<ProductUnit>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  useNumpy?: Maybe<Scalars['Boolean']['output']>;
  userUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type EquationFilter = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  showMaster?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type EquationMap = {
  __typename?: 'EquationMap';
  abLinesEquationGrid?: Maybe<AbLinesEquationGrid>;
  area: Scalars['Float']['output'];
  attributesJson?: Maybe<Scalars['AWSJSON']['output']>;
  attributesUrl?: Maybe<Scalars['String']['output']>;
  boundingBox: Array<Maybe<Scalars['Float']['output']>>;
  centroid: Centroid;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  dataVariables?: Maybe<Array<Maybe<DataVariable>>>;
  equation?: Maybe<Equation>;
  equationAsText?: Maybe<Scalars['String']['output']>;
  equationMapGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  equationMapUrl?: Maybe<Scalars['String']['output']>;
  equationResultVariable: Scalars['String']['output'];
  fieldUuid: Scalars['ID']['output'];
  geoJsonUrl?: Maybe<Scalars['String']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<EquationMapParameters>;
  productUnit?: Maybe<ProductUnit>;
  statistics?: Maybe<EquationMapStatistics>;
  status: AnalysisMapStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VectorAnalysisMapType>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  useNumpy?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
  variabilityFactor?: Maybe<Scalars['Float']['output']>;
};


export type EquationMapAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type EquationMapAttributesJsonArgs = {
  asMultiGeometry?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<AreaUnit>;
};


export type EquationMapEquationMapGeojsonArgs = {
  asMultiGeometry?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<AreaUnit>;
};


export type EquationMapGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EquationMapAsync = {
  __typename?: 'EquationMapAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type EquationMapParameters = {
  __typename?: 'EquationMapParameters';
  gridPixelSizeX?: Maybe<Scalars['Int']['output']>;
  gridPixelSizeY?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['Float']['output']>;
};

export type EquationMapStatistics = {
  __typename?: 'EquationMapStatistics';
  avg?: Maybe<Scalars['Float']['output']>;
  cnt?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  mdn?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  std?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
  uniqueArr?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  uniqueCnt?: Maybe<Scalars['Int']['output']>;
  var?: Maybe<Scalars['Float']['output']>;
};

export type EquipmentCnh = {
  __typename?: 'EquipmentCNH';
  brand: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  devices?: Maybe<Array<Maybe<EquipmentDeviceCnh>>>;
  model: Scalars['String']['output'];
  nickName: Scalars['String']['output'];
  productLine: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  vin: Scalars['String']['output'];
};

export type EquipmentDeviceCnh = {
  __typename?: 'EquipmentDeviceCNH';
  model: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type ExecutePaymentTransactionInput = {
  amount: Scalars['Float']['input'];
  nonce: Scalars['String']['input'];
};

export type ExecuteZonesOperationInput = {
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  zonesOperation: ZonesOperationType;
  zonesOperationMaps: Array<InputMaybe<VectorAnalysisMapForZonesOperationInput>>;
};

export type ExportCnhFieldToGeoPardInput = {
  companyId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
};

export type ExportCnhFieldsToGeoPardInput = {
  companyId: Scalars['ID']['input'];
  farmId: Scalars['ID']['input'];
};

export type ExportCnhOperationToGeoPardInput = {
  companyId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
};

export type ExportClimateFieldDatasetToGeoPardInput = {
  dataType: DataTypeClimate;
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  fieldUuid: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ExportData = {
  __typename?: 'ExportData';
  archiveUrl?: Maybe<Scalars['String']['output']>;
  ignoredAdmDatasets?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredEquationMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredFieldBoundaries?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredIsoXmlMaps?: Maybe<Array<Maybe<ExportDataObjects>>>;
  ignoredNotes?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredSamplingPlans?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredVectorAnalysisMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
  ignoredYieldMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedAdmDatasets?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedEquationMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedFieldBoundaries?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedIsoXmlMaps?: Maybe<Array<Maybe<ExportDataObjects>>>;
  zippedNotes?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedSamplingPlans?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedVectorAnalysisMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
  zippedYieldMaps?: Maybe<Array<Maybe<ExportDataObject>>>;
};

export type ExportDataInput = {
  archiveName?: InputMaybe<Scalars['String']['input']>;
  asMultiGeometry?: InputMaybe<Scalars['Boolean']['input']>;
  displayFormat?: InputMaybe<DisplayFormat>;
  equationMaps?: InputMaybe<Array<InputMaybe<ExportDataObjectInput>>>;
  fieldBoundaries?: InputMaybe<Array<InputMaybe<ExportDataObjectInput>>>;
  fieldBoundariesToJohnDeere?: InputMaybe<Array<InputMaybe<ExportFieldObjectToJohnDeereInput>>>;
  filePostfix?: InputMaybe<Scalars['String']['input']>;
  incorporateAssociatedTrials?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<InputMaybe<ExportDataObjectWithEntityInput>>>;
  onlyProductColumns?: InputMaybe<Scalars['Boolean']['input']>;
  samplingPlans?: InputMaybe<Array<InputMaybe<ExportDataObjectInput>>>;
  vectorAnalysisMaps?: InputMaybe<Array<InputMaybe<ExportDataObjectInput>>>;
  vectorAnalysisMapsToJohnDeere?: InputMaybe<Array<InputMaybe<ExportDataObjectInput>>>;
};

export type ExportDataObject = {
  __typename?: 'ExportDataObject';
  fieldUuid: Scalars['ID']['output'];
  status: ExportStatus;
  uuid: Scalars['ID']['output'];
};

export type ExportDataObjectInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type ExportDataObjectWithEntityInput = {
  entity: TreeNodeEntity;
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type ExportDataObjects = {
  __typename?: 'ExportDataObjects';
  fieldUuid: Scalars['ID']['output'];
  status: ExportStatus;
  uuids: Array<Maybe<Scalars['ID']['output']>>;
};

export type ExportDataObjectsInput = {
  fieldUuid: Scalars['ID']['input'];
  uuids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ExportFieldObjectToJohnDeereInput = {
  clientNameInJohnDeere: Scalars['String']['input'];
  farmNameInJohnDeere: Scalars['String']['input'];
  farmUuid: Scalars['ID']['input'];
  fieldNameInJohnDeere: Scalars['String']['input'];
  fieldUuid: Scalars['ID']['input'];
};

export type ExportGeoPardFieldToClimateAsFileInput = {
  fieldUuid: Scalars['ID']['input'];
};

export type ExportGeoPardFieldsToJohnDeereAsFilesInput = {
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ExportGeoPardRxToCnhAsFileInput = {
  activityTypeId: Scalars['String']['input'];
  activityUnitOfMeasureId: Scalars['String']['input'];
  archiveName: Scalars['String']['input'];
  archiveUrl: Scalars['String']['input'];
  areaUnitOfMeasureId: Scalars['String']['input'];
  attributeName: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  equipmentVin: Scalars['String']['input'];
  fieldId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  seasonId: Scalars['String']['input'];
};

export type ExportGeoPardRxToClimateAsFileInput = {
  archiveName: Scalars['String']['input'];
  archiveUrl: Scalars['String']['input'];
  fieldUuid: Scalars['ID']['input'];
};

export type ExportGeoPardYieldDataToClimateAsFileInput = {
  archiveName: Scalars['String']['input'];
  archiveUrl: Scalars['String']['input'];
  fieldUuid: Scalars['ID']['input'];
};

export type ExportIsoXmlInput = {
  applicationMaps?: InputMaybe<Array<InputMaybe<ExportDataObjectsInput>>>;
  archiveName?: InputMaybe<Scalars['String']['input']>;
  equationMaps?: InputMaybe<Array<InputMaybe<ExportDataObjectsInput>>>;
  filePostfix?: InputMaybe<Scalars['String']['input']>;
  incorporateAssociatedTrials?: InputMaybe<Scalars['Boolean']['input']>;
  isoXmlExportType?: InputMaybe<IsoXmlExportType>;
  isoXmlVersion?: InputMaybe<IsoXmlVersion>;
  perFieldExport?: InputMaybe<Scalars['Boolean']['input']>;
  rasterCellHeight?: InputMaybe<Scalars['Int']['input']>;
  rasterCellWidth?: InputMaybe<Scalars['Int']['input']>;
};

export enum ExportStatus {
  AdmNotGenerated = 'ADM_NOT_GENERATED',
  IsoxmlNotGenerated = 'ISOXML_NOT_GENERATED',
  KmlNotGenerated = 'KML_NOT_GENERATED',
  NotPurchased = 'NOT_PURCHASED',
  ShapefileNotGenerated = 'SHAPEFILE_NOT_GENERATED',
  Zipped = 'ZIPPED'
}

export type ExportToJohnDeereAsAdmInput = {
  archiveName?: InputMaybe<Scalars['String']['input']>;
  clientNameInJohnDeere: Scalars['String']['input'];
  exportType?: InputMaybe<ExportType>;
  farmNameInJohnDeere: Scalars['String']['input'];
  fieldNameInJohnDeere: Scalars['String']['input'];
  fieldUuid: Scalars['ID']['input'];
  filePostfix?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ExportToJohnDeereAsApplicationWorkPlanInput = {
  chemicalArchiveName?: InputMaybe<Scalars['String']['input']>;
  chemicalArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  chemicalId?: InputMaybe<Scalars['String']['input']>;
  chemicalUnit?: InputMaybe<Scalars['String']['input']>;
  chemicalValue?: InputMaybe<Scalars['String']['input']>;
  dryBlendArchiveName?: InputMaybe<Scalars['String']['input']>;
  dryBlendArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  dryBlendId?: InputMaybe<Scalars['String']['input']>;
  dryBlendUnit?: InputMaybe<Scalars['String']['input']>;
  dryBlendValue?: InputMaybe<Scalars['String']['input']>;
  fertilizerArchiveName?: InputMaybe<Scalars['String']['input']>;
  fertilizerArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  fertilizerId?: InputMaybe<Scalars['String']['input']>;
  fertilizerUnit?: InputMaybe<Scalars['String']['input']>;
  fertilizerValue?: InputMaybe<Scalars['String']['input']>;
  fieldUuid: Scalars['String']['input'];
  tankMixArchiveName?: InputMaybe<Scalars['String']['input']>;
  tankMixArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  tankMixId?: InputMaybe<Scalars['String']['input']>;
  tankMixUnit?: InputMaybe<Scalars['String']['input']>;
  tankMixValue?: InputMaybe<Scalars['String']['input']>;
};

export type ExportToJohnDeereAsFilesInput = {
  archiveName: Scalars['String']['input'];
  archiveUrl: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};

export type ExportToJohnDeereAsMapsLayersInput = {
  equationMapUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  satelliteImageUuid?: InputMaybe<Scalars['ID']['input']>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  topographyMapUuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
  yieldDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ExportToJohnDeereAsSeedingWorkPlanInput = {
  /**  DEPRECATED */
  archiveName?: InputMaybe<Scalars['String']['input']>;
  /**  DEPRECATED */
  archiveUrl?: InputMaybe<Scalars['String']['input']>;
  chemicalArchiveName?: InputMaybe<Scalars['String']['input']>;
  chemicalArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  chemicalId?: InputMaybe<Scalars['String']['input']>;
  chemicalUnit?: InputMaybe<Scalars['String']['input']>;
  chemicalValue?: InputMaybe<Scalars['String']['input']>;
  dryBlendArchiveName?: InputMaybe<Scalars['String']['input']>;
  dryBlendArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  dryBlendId?: InputMaybe<Scalars['String']['input']>;
  dryBlendUnit?: InputMaybe<Scalars['String']['input']>;
  dryBlendValue?: InputMaybe<Scalars['String']['input']>;
  fertilizerArchiveName?: InputMaybe<Scalars['String']['input']>;
  fertilizerArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  fertilizerId?: InputMaybe<Scalars['String']['input']>;
  fertilizerUnit?: InputMaybe<Scalars['String']['input']>;
  fertilizerValue?: InputMaybe<Scalars['String']['input']>;
  fieldUuid: Scalars['String']['input'];
  tankMixArchiveName?: InputMaybe<Scalars['String']['input']>;
  tankMixArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  tankMixId?: InputMaybe<Scalars['String']['input']>;
  tankMixUnit?: InputMaybe<Scalars['String']['input']>;
  tankMixValue?: InputMaybe<Scalars['String']['input']>;
  varietyArchiveName?: InputMaybe<Scalars['String']['input']>;
  varietyArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  varietyId: Scalars['String']['input'];
  varietyUnit?: InputMaybe<Scalars['String']['input']>;
  varietyValue?: InputMaybe<Scalars['String']['input']>;
};

export enum ExportType {
  AsApplied = 'AS_APPLIED',
  Yield = 'YIELD'
}

export type ExtractFileMetaData = {
  __typename?: 'ExtractFileMetaData';
  associatedFields?: Maybe<Array<Maybe<ExtractFileMetaDataField>>>;
  associatedFullAttributes?: Maybe<Array<Maybe<AssociatedFullAttribute>>>;
  headerDetection?: Maybe<HeaderDetection>;
  metadataFields?: Maybe<Array<Maybe<MetadataField>>>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
};

export type ExtractFileMetaDataField = {
  __typename?: 'ExtractFileMetaDataField';
  associatedSamplingPlans?: Maybe<Array<Maybe<SamplingPlan>>>;
  confidence?: Maybe<Scalars['Float']['output']>;
  farmUuid: Scalars['ID']['output'];
  fieldName: Scalars['String']['output'];
  internalLabels?: Maybe<Array<Maybe<Label>>>;
  labels?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  uuid: Scalars['ID']['output'];
};

export type ExtractFileMetaDataInput = {
  s3Key: Scalars['String']['input'];
  s3Url: Scalars['String']['input'];
};

export type Farm = {
  __typename?: 'Farm';
  createdDate: Scalars['AWSDateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalKey?: Maybe<Scalars['String']['output']>;
  farmOwnership: FarmOwnership;
  fields: Array<Maybe<Field>>;
  name: Scalars['String']['output'];
  ownerEmail?: Maybe<Scalars['String']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  userUuid: Scalars['ID']['output'];
  usersEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid: Scalars['ID']['output'];
};


export type FarmFieldsArgs = {
  externalKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldStatuses?: InputMaybe<Array<InputMaybe<FieldStatus>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type FarmCnh = {
  __typename?: 'FarmCNH';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FarmEngage = {
  __typename?: 'FarmEngage';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FarmFilter = {
  farmExternalKey?: InputMaybe<Scalars['String']['input']>;
  farmName?: InputMaybe<Scalars['String']['input']>;
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type FarmFilterCnh = {
  companyId: Scalars['ID']['input'];
  growerId: Scalars['ID']['input'];
};

export enum FarmOwnership {
  Own = 'OWN',
  Shared = 'SHARED'
}

export type FertilizerCnh = {
  __typename?: 'FertilizerCNH';
  createdDate: Scalars['String']['output'];
  density: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productFormId: Scalars['String']['output'];
  unitCost: Scalars['String']['output'];
};

export type FetchSatelliteImageryDataByGeometryInput = {
  endDate: Scalars['AWSDateTime']['input'];
  geojson: Scalars['AWSJSON']['input'];
  index: Index;
  providers: Array<InputMaybe<SatelliteImageProvider>>;
  ranges?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  startDate: Scalars['AWSDateTime']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type Field = {
  __typename?: 'Field';
  activatedElevationProcessing?: Maybe<Scalars['Boolean']['output']>;
  activatedSatimageProcessing?: Maybe<Scalars['Boolean']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  asAppliedDatasets?: Maybe<Array<Maybe<AsAppliedDataset>>>;
  boundaryUrl?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  creationType: FieldCreationType;
  equationMaps?: Maybe<Array<Maybe<EquationMap>>>;
  externalKey?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['ID']['output'];
  genericSatelliteImageryStatus?: Maybe<SatelliteImageryProcessingStatus>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  isSynchronizedJohnDeereField?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Maybe<Label>>>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  planetArchiveSatelliteImageryStatus?: Maybe<SatelliteImageryProcessingStatus>;
  planetSatelliteImageryStatus?: Maybe<SatelliteImageryProcessingStatus>;
  rasterAnalysisMaps?: Maybe<Array<Maybe<RasterAnalysisMap>>>;
  reports?: Maybe<Array<Maybe<Report>>>;
  samplingPlans?: Maybe<Array<Maybe<SamplingPlan>>>;
  satelliteImages?: Maybe<Array<Maybe<FieldSatelliteImage>>>;
  soilDatasets?: Maybe<Array<Maybe<SoilDataset>>>;
  status: FieldStatus;
  statusMessage: Scalars['String']['output'];
  threeDimensionalMaps?: Maybe<Array<Maybe<ThreeDimensionalMap>>>;
  topographyMaps?: Maybe<Array<Maybe<TopographyMap>>>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  vectorAnalysisMaps?: Maybe<Array<Maybe<VectorAnalysisMap>>>;
  yieldDatasets?: Maybe<Array<Maybe<YieldDataset>>>;
};


export type FieldAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type FieldAsAppliedDatasetsArgs = {
  asAppliedDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
};


export type FieldEquationMapsArgs = {
  equationMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<AnalysisMapStatus>>>;
};


export type FieldGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FieldNotesArgs = {
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NoteType>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
};


export type FieldRasterAnalysisMapsArgs = {
  rasterAnalysisMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldReportsArgs = {
  reportUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldSamplingPlansArgs = {
  batchUuid?: InputMaybe<Scalars['ID']['input']>;
  noteTypes?: InputMaybe<Array<InputMaybe<NoteType>>>;
  planStatuses?: InputMaybe<Array<InputMaybe<SamplingPlanStatus>>>;
  planTypes?: InputMaybe<Array<InputMaybe<SamplingPlanType>>>;
  planUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vectorAnalysisMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldSatelliteImagesArgs = {
  after?: InputMaybe<Scalars['AWSDate']['input']>;
  before?: InputMaybe<Scalars['AWSDate']['input']>;
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<SatelliteImageProvider>;
  ranges?: InputMaybe<Array<InputMaybe<SatelliteImageRangeInput>>>;
  satelliteImageUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};


export type FieldSoilDatasetsArgs = {
  soilDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
};


export type FieldThreeDimensionalMapsArgs = {
  threeDimensionalMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldTopographyMapsArgs = {
  statuses?: InputMaybe<Array<InputMaybe<AnalysisMapStatus>>>;
  topographyMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldVectorAnalysisMapsArgs = {
  statuses?: InputMaybe<Array<InputMaybe<AnalysisMapStatus>>>;
  vectorAnalysisMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type FieldYieldDatasetsArgs = {
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
  yieldDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type FieldCnh = {
  __typename?: 'FieldCNH';
  boundaryCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum FieldCreationType {
  Autocreated = 'AUTOCREATED',
  Geojson = 'GEOJSON',
  Shapefile = 'SHAPEFILE'
}

export type FieldFilter = {
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  farmUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldExternalKey?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldStatuses?: InputMaybe<Array<InputMaybe<FieldStatus>>>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  labels?: InputMaybe<Array<InputMaybe<LabelInput>>>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type FieldFilterCnh = {
  companyId: Scalars['ID']['input'];
  farmId: Scalars['ID']['input'];
};

export type FieldFilterJohnDeere = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldUuid?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type FieldHierarchyMappingClimate = {
  __typename?: 'FieldHierarchyMappingClimate';
  account?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  farm?: Maybe<Scalars['String']['output']>;
  hasSpecificMapping?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldJohnDeere = {
  __typename?: 'FieldJohnDeere';
  area: Scalars['Float']['output'];
  areaUnit: AreaUnit;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['ID']['output'];
  synchronized?: Maybe<SynchronizedField>;
};

export type FieldJohnDeereInput = {
  id: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};

export type FieldLabels = {
  farmUuid: Scalars['ID']['input'];
  labels?: InputMaybe<Array<InputMaybe<LabelInput>>>;
  uuid: Scalars['ID']['input'];
};

export type FieldOperationFilterJohnDeere = {
  cropSeasons?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldOperationTypes?: InputMaybe<Array<InputMaybe<FieldOperationJohnDeereTypes>>>;
  fields: Array<InputMaybe<FieldJohnDeereInput>>;
};

export type FieldOperationJohnDeereSeasons = {
  __typename?: 'FieldOperationJohnDeereSeasons';
  cropSeason?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FieldOperationJohnDeereStatistics = {
  __typename?: 'FieldOperationJohnDeereStatistics';
  fieldOperationType?: Maybe<FieldOperationJohnDeereTypes>;
  seasons?: Maybe<Array<Maybe<FieldOperationJohnDeereSeasons>>>;
};

export enum FieldOperationJohnDeereTypes {
  Application = 'APPLICATION',
  Harvest = 'HARVEST',
  Seeding = 'SEEDING',
  Tillage = 'TILLAGE'
}

export type FieldSatelliteImage = {
  __typename?: 'FieldSatelliteImage';
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid: Centroid;
  cloudFreeLand?: Maybe<Scalars['Float']['output']>;
  cloudFreeLandConfidence?: Maybe<Scalars['Float']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  fieldUuid: Scalars['ID']['output'];
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  ndviAverage?: Maybe<Scalars['Float']['output']>;
  ndviVariation?: Maybe<Scalars['Float']['output']>;
  provider: SatelliteImageProvider;
  rangeCoverage?: Maybe<Array<Maybe<SatelliteImageIndexRangeCoverage>>>;
  recomendedForMutliYearAnalytics?: Maybe<Scalars['Boolean']['output']>;
  satelliteImage: SatelliteImage;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<SatelliteImageIndexStatistics>>>;
  status?: Maybe<DatasetStatus>;
  transparentCloudLand?: Maybe<Scalars['Float']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
};


export type FieldSatelliteImageGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FieldSatelliteImageSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type FieldSatelliteImageSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};

export enum FieldStatus {
  Added = 'ADDED',
  Deleted = 'DELETED',
  GridsCreated = 'GRIDS_CREATED',
  Invalid = 'INVALID',
  TilesIgnored = 'TILES_IGNORED',
  TilesRegistered = 'TILES_REGISTERED',
  Verified = 'VERIFIED'
}

export type FieldWithFieldsOperationsStatisticsJohnDeere = {
  __typename?: 'FieldWithFieldsOperationsStatisticsJohnDeere';
  fieldOperations?: Maybe<Array<Maybe<FieldOperationJohnDeereStatistics>>>;
  id: Scalars['ID']['output'];
  orgId: Scalars['ID']['output'];
};

export type FieldsWithFieldsOperationsStatisticsJohnDeere = {
  __typename?: 'FieldsWithFieldsOperationsStatisticsJohnDeere';
  fields?: Maybe<Array<Maybe<FieldWithFieldsOperationsStatisticsJohnDeere>>>;
};

export type FilterNotesInput = {
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  noteUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NoteType>;
  uuid: Scalars['ID']['input'];
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterUserBatchesInput = {
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  farmUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<UserBatchFiltersInput>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<UserBatchSortCriteriaInput>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type FindPlanetMasksInput = {
  endDate: Scalars['AWSDate']['input'];
  fieldUuid: Scalars['ID']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type FlushProfileClimateInput = {
  email: Scalars['String']['input'];
};

export type FullAttribute = {
  __typename?: 'FullAttribute';
  fullName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  samples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  transliteratedName?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<AttributeUnit>;
};

export type GenerateAsAppliedRasterAnalysisMapInput = {
  asAppliedAttribute: Scalars['String']['input'];
  asAppliedDatasetUuid: Scalars['ID']['input'];
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateAsAppliedVectorAnalysisMapInput = {
  asAppliedAttribute: Scalars['String']['input'];
  asAppliedDatasetUuid: Scalars['ID']['input'];
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateCortevaZonesMapAsyncWithIncludeLogicInput = {
  fieldUuid: Scalars['ID']['input'];
  includedSatelliteImagesYears?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includedYieldDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  rule: AgronomicRule;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateEquationMapInput = {
  abLinesEquationGrid?: InputMaybe<AbLinesEquationGridInput>;
  dataVariables?: InputMaybe<Array<InputMaybe<DataVariableInput>>>;
  equationAsText?: InputMaybe<Scalars['String']['input']>;
  equationResultVariable?: InputMaybe<Scalars['String']['input']>;
  equationUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid: Scalars['ID']['input'];
  gridPixelSizeX?: InputMaybe<Scalars['Int']['input']>;
  gridPixelSizeY?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productUnit?: InputMaybe<ProductUnit>;
  type?: InputMaybe<VectorAnalysisMapType>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  useNumpy?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateEquationVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  equationMapUuid: Scalars['ID']['input'];
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateMultiLayersRasterAnalysisMapInput = {
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  dataLayers: Array<InputMaybe<DataLayerInput>>;
  fieldUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateMultiLayersVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  dataLayers: Array<InputMaybe<DataLayerInput>>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GeneratePfeiferLangenVectorAnalysisMapsInput = {
  fieldUuid: Scalars['ID']['input'];
};

export type GeneratePresignedPostFileDataInput = {
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fileExtension?: InputMaybe<UploadFileExtension>;
  fileType: UploadFileType;
  ignoreAutoProcessing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneratePresignedPostPhotoDataInput = {
  commentUuid?: InputMaybe<Scalars['ID']['input']>;
  farmUuid: Scalars['ID']['input'];
  fieldUuid: Scalars['ID']['input'];
  fileExtention: PhotoExtention;
  noteUuid: Scalars['ID']['input'];
};

export type GenerateRasterAnalysisMapInput = {
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  index: Index;
  satelliteImageUuids: Array<InputMaybe<Scalars['ID']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateReportInput = {
  assets: Array<InputMaybe<ReportAssetInput>>;
  farmUuid: Scalars['ID']['input'];
  fieldUuid: Scalars['ID']['input'];
  format?: InputMaybe<ReportFormat>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateReportsInput = {
  reports: Array<InputMaybe<GenerateReportInput>>;
};

export type GenerateSoilRasterAnalysisMapInput = {
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  soilAttribute: Scalars['String']['input'];
  soilDatasetUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateSoilVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  soilAttribute: Scalars['String']['input'];
  soilDatasetUuid: Scalars['ID']['input'];
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateStripeInvoicePreviewInput = {
  address?: InputMaybe<StripeCustomerAddressInput>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<StripeSubscriptionItemInput>>>;
  promocode?: InputMaybe<Scalars['String']['input']>;
  taxIdData?: InputMaybe<Array<InputMaybe<StripeTaxIdDataInput>>>;
};

export type GenerateSyntheticYieldDatasetInput = {
  crop: CropEnum;
  fieldUuid: Scalars['ID']['input'];
  harvestStartDate: Scalars['AWSDateTime']['input'];
  harvestYear: Scalars['Int']['input'];
  yieldAttribute?: InputMaybe<Scalars['String']['input']>;
  yieldAverage?: InputMaybe<Scalars['Float']['input']>;
  yieldDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  yieldTotal?: InputMaybe<Scalars['Float']['input']>;
  yieldUnit?: InputMaybe<AttributeUnit>;
};

export type GenerateTopographyRasterAnalysisMapInput = {
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  topographyAttribute: TopographyAttribute;
  topographyMapUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateTopographyVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  topographyAttribute: TopographyAttribute;
  topographyMapUuid: Scalars['ID']['input'];
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateVectorAnalysisMapFromRasterInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  rasterAnalysisMapUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  index: Index;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  satelliteImageUuids: Array<InputMaybe<Scalars['ID']['input']>>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateYieldRasterAnalysisMapInput = {
  /**  pixelSize: Int! */
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
  yieldAttribute: Scalars['String']['input'];
  yieldDatasetUuid: Scalars['ID']['input'];
};

export type GenerateYieldVectorAnalysisMapInput = {
  dataClassificationType?: InputMaybe<DataClassificationType>;
  fieldUuid: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfZones: Scalars['Int']['input'];
  polygonMinArea?: InputMaybe<Scalars['Float']['input']>;
  useInterpolatedData?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  yieldAttribute: Scalars['String']['input'];
  yieldDatasetUuid: Scalars['ID']['input'];
};

export enum GeoFormat {
  Geojson = 'GEOJSON',
  Geotiff = 'GEOTIFF'
}

export type GeoMap = {
  __typename?: 'GeoMap';
  classes?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hexColorCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortName: Scalars['String']['output'];
  url: Scalars['String']['output'];
  urlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  urlExcludedParameters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  urlPath?: Maybe<Scalars['String']['output']>;
};

export type GeoMapInput = {
  classes?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**  TODO implement other Data Layers here */
  fieldUuid: Scalars['ID']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  hexColorCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortName: Scalars['String']['input'];
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
};

export enum GeoMapType {
  All = 'ALL',
  Contrast = 'CONTRAST',
  Cropped = 'CROPPED',
  Origin = 'ORIGIN',
  Processed = 'PROCESSED',
  Raw = 'RAW',
  RawContrast = 'RAW_CONTRAST',
  RawCropped = 'RAW_CROPPED',
  Thumbnail = 'THUMBNAIL'
}

export enum GeometryType {
  Multipoints = 'MULTIPOINTS',
  Multipolygons = 'MULTIPOLYGONS',
  Points = 'POINTS',
  Polygons = 'POLYGONS'
}

export type GetStripeCustomerInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
};

export type Grid = {
  __typename?: 'Grid';
  angle: Scalars['Float']['output'];
  size: Scalars['Float']['output'];
};


export type GridSizeArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type GridInput = {
  angle: Scalars['Float']['input'];
  size: Scalars['Float']['input'];
};

export type GrowerCnh = {
  __typename?: 'GrowerCNH';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GrowerFilterCnh = {
  companyId: Scalars['ID']['input'];
};

export type GuidanceLinesFilterJohnDeere = {
  fieldId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GuidanceLinesJohnDeere = {
  __typename?: 'GuidanceLinesJohnDeere';
  aPoint?: Maybe<GuidancePointJohnDeere>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  bPoint?: Maybe<GuidancePointJohnDeere>;
  eastShift?: Maybe<GuidanceMeasurementAsDoubleJohnDeere>;
  heading?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  northShift?: Maybe<GuidanceMeasurementAsDoubleJohnDeere>;
  referencePoint?: Maybe<GuidancePointJohnDeere>;
  spatialProjection?: Maybe<GuidanceSpatialProjectionJohnDeere>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GuidanceMeasurementAsDoubleJohnDeere = {
  __typename?: 'GuidanceMeasurementAsDoubleJohnDeere';
  type?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  valueAsDouble?: Maybe<Scalars['String']['output']>;
  vrDomainId?: Maybe<Scalars['String']['output']>;
};

export type GuidancePointJohnDeere = {
  __typename?: 'GuidancePointJohnDeere';
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GuidanceSpatialProjectionJohnDeere = {
  __typename?: 'GuidanceSpatialProjectionJohnDeere';
  projectionType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HeaderDetection = {
  __typename?: 'HeaderDetection';
  confidence?: Maybe<Scalars['Float']['output']>;
  dataStartLine?: Maybe<Scalars['Int']['output']>;
  headerLines?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type HeaderDetectionInput = {
  dataStartLine?: InputMaybe<Scalars['Int']['input']>;
  headerLines?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ImportAllFromJohnDeereInput = {
  cropSeasons?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldOperationTypes?: InputMaybe<Array<InputMaybe<FieldOperationJohnDeereTypes>>>;
  importType?: InputMaybe<ImportJohnDeereType>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ImportDataObject = {
  __typename?: 'ImportDataObject';
  farmUuid?: Maybe<Scalars['ID']['output']>;
  fieldUuid: Scalars['ID']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  status: ImportStatus;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ImportFromJohnDeereInput = {
  cropSeasons?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldOperationTypes?: InputMaybe<Array<InputMaybe<FieldOperationJohnDeereTypes>>>;
  fields: Array<InputMaybe<FieldJohnDeereInput>>;
  importType?: InputMaybe<ImportJohnDeereType>;
};

export enum ImportJohnDeereType {
  DataFiles = 'DATA_FILES',
  FieldBoundaries = 'FIELD_BOUNDARIES',
  FieldOperationFiles = 'FIELD_OPERATION_FILES'
}

export enum ImportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum Index {
  Ccci = 'CCCI',
  Evi2 = 'EVI2',
  Gci = 'GCI',
  Gfpi = 'GFPI',
  Gndvi = 'GNDVI',
  Ipvi = 'IPVI',
  Lai = 'LAI',
  Mcari = 'MCARI',
  Mcari1 = 'MCARI1',
  McariOsavi = 'MCARI_OSAVI',
  Msi = 'MSI',
  Ndmi = 'NDMI',
  Ndvi = 'NDVI',
  Ndwi = 'NDWI',
  Ndyi = 'NDYI',
  Nir = 'NIR',
  Osavi = 'OSAVI',
  Rci = 'RCI',
  Rvi = 'RVI',
  Savi = 'SAVI',
  Sbi = 'SBI',
  Tcari = 'TCARI',
  TcariOsavi = 'TCARI_OSAVI',
  Wdrvi = 'WDRVI'
}

export enum IsoXmlExportType {
  RasterGridType_1 = 'RASTER_GRID_TYPE_1',
  RasterGridType_2 = 'RASTER_GRID_TYPE_2',
  Vector = 'VECTOR'
}

export enum IsoXmlVersion {
  V3 = 'V3',
  V4 = 'V4'
}

export type JohnDeere = {
  __typename?: 'JohnDeere';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  flushDateRefreshToken?: Maybe<Scalars['AWSDateTime']['output']>;
  flushUserRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateEquationMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateSatelliteImageMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateSoilMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateTopographyMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateYieldMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateZonesMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoImportAllFieldOperations?: Maybe<Scalars['Boolean']['output']>;
  hasAutoUpdateFieldBoundaries?: Maybe<Scalars['Boolean']['output']>;
  hasAutoUpdateFieldStructure?: Maybe<Scalars['Boolean']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
  providerHealthCheck?: Maybe<Scalars['Boolean']['output']>;
  updateAcceptUrl?: Maybe<Scalars['String']['output']>;
};

export type Key = {
  __typename?: 'Key';
  PartitionKey: Scalars['String']['output'];
  SortKey: Scalars['String']['output'];
  TagString?: Maybe<Scalars['String']['output']>;
};

export type KeyInput = {
  PartitionKey: Scalars['String']['input'];
  SortKey: Scalars['String']['input'];
  TagString?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Label = {
  __typename?: 'Label';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LabelInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LabelsInput = {
  labelNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum Language {
  Bg = 'bg',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Hu = 'hu',
  It = 'it',
  Nl = 'nl',
  Pt = 'pt',
  PtBr = 'pt_br',
  Ro = 'ro',
  Ru = 'ru',
  Sl = 'sl',
  Ua = 'ua',
  Uk = 'uk'
}

export type LinkOrganizationJohnDeere = {
  __typename?: 'LinkOrganizationJohnDeere';
  rel: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  code?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type Machine = {
  __typename?: 'Machine';
  id?: Maybe<Scalars['String']['output']>;
  operatorId?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
};

export type ManageConfigInput = {
  configurationProfile: ConfigurationProfile;
  environment: Environment;
};

export type ManageProfileClimate = {
  __typename?: 'ManageProfileClimate';
  fieldHierarchyMapping?: Maybe<FieldHierarchyMappingClimate>;
};

export type ManageProfileClimateInput = {
  accountFieldHierarchyMapping?: InputMaybe<Scalars['String']['input']>;
  clientFieldHierarchyMapping?: InputMaybe<Scalars['String']['input']>;
  farmFieldHierarchyMapping?: InputMaybe<Scalars['String']['input']>;
};

export type ManageProfileJohnDeere = {
  __typename?: 'ManageProfileJohnDeere';
  hasAutoCreateEquationMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateSatelliteImageMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateSoilMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateTopographyMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateYieldMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoCreateZonesMapLayers?: Maybe<Scalars['Boolean']['output']>;
  hasAutoImportAllFieldOperations?: Maybe<Scalars['Boolean']['output']>;
  hasAutoUpdateFieldBoundaries?: Maybe<Scalars['Boolean']['output']>;
  hasAutoUpdateFieldStructure?: Maybe<Scalars['Boolean']['output']>;
};

export type ManageProfileJohnDeereInput = {
  hasAutoCreateEquationMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoCreateSatelliteImageMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoCreateSoilMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoCreateTopographyMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoCreateYieldMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoCreateZonesMapLayers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoImportAllFieldOperations?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoUpdateFieldBoundaries?: InputMaybe<Scalars['Boolean']['input']>;
  hasAutoUpdateFieldStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MetadataField = {
  __typename?: 'MetadataField';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalText?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MetadataFieldType>;
};

export type MetadataFieldInput = {
  columnIndex?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalText?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetadataFieldType>;
};

export enum MetadataFieldType {
  AnalysisDate = 'analysis_date',
  Coordinates = 'coordinates',
  FieldId = 'field_id',
  FieldName = 'field_name',
  LabId = 'lab_id',
  Labels = 'labels',
  Latitude = 'latitude',
  Longitude = 'longitude',
  ZoneId = 'zone_id'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateCortevaPlanetData?: Maybe<PlanetArchiveAsync>;
  addColorSchemas?: Maybe<Array<Maybe<ColorSchema>>>;
  addFieldLabels?: Maybe<Array<Maybe<Field>>>;
  addNoteComment?: Maybe<Comment>;
  addNoteComments?: Maybe<Array<Maybe<Comment>>>;
  addUsersToOrganization?: Maybe<Array<Maybe<UserOrganization>>>;
  /**  DEPRECATED */
  addVectorAnalysisMapToShoppingCart?: Maybe<ShoppingCart>;
  assembleCube?: Maybe<CubeAssemblyOutput>;
  calibrateYieldDataset: YieldDatasetAsync;
  changeUserStatus?: Maybe<UserData>;
  checkCortevaPreBillingPlanetData?: Maybe<PreBillingPlanetStatistics>;
  /**  DEPRECATED */
  cleanShoppingCart?: Maybe<ShoppingCart>;
  completeSamplingPlan?: Maybe<CompleteSamplingPlan>;
  confirmFileUpload?: Maybe<ConfirmFileUpload>;
  createFarm: Farm;
  createFieldOperationSubscriptionJohnDeere?: Maybe<SubscriptionJohnDeere>;
  createHarvestPlantingApplicationSubscriptionClimate?: Maybe<SubscriptionClimate>;
  createOperationSubscriptionCNH?: Maybe<SubscriptionCnh>;
  createSamplingPlan?: Maybe<SamplingPlan>;
  deleteAsAppliedDataset?: Maybe<AsAppliedDataset>;
  deleteColorSchemas?: Maybe<Array<Maybe<ColorSchema>>>;
  deleteEquation?: Maybe<Equation>;
  deleteEquationMap?: Maybe<EquationMap>;
  deleteFarm?: Maybe<Farm>;
  deleteFarms?: Maybe<Array<Maybe<Farm>>>;
  deleteField?: Maybe<Field>;
  deleteFieldLabels?: Maybe<Array<Maybe<Field>>>;
  deleteFields?: Maybe<Array<Maybe<Field>>>;
  deleteLabel?: Maybe<Label>;
  deleteNote?: Maybe<Note>;
  deleteNotes?: Maybe<Array<Maybe<Note>>>;
  deletePhoto?: Maybe<Photo>;
  deletePhotos?: Maybe<Array<Maybe<Photo>>>;
  deleteRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  deleteSamplingPlans?: Maybe<DeleteSamplingPlans>;
  deleteSoilDataset?: Maybe<SoilDataset>;
  deleteSubscriptionCNH?: Maybe<ResponseOperationCnh>;
  deleteSubscriptionClimate?: Maybe<SubscriptionClimate>;
  deleteSubscriptionJohnDeere?: Maybe<SubscriptionJohnDeere>;
  deleteThreeDimensionalMap?: Maybe<ThreeDimensionalMap>;
  deleteTopographyDataset?: Maybe<TopographyMap>;
  deleteTrial?: Maybe<Trial>;
  deleteUserBatch?: Maybe<DeleteUserBatch>;
  deleteUsersFromOrganization?: Maybe<Array<Maybe<UserOrganization>>>;
  deleteVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  deleteYieldDataset?: Maybe<YieldDataset>;
  disableSubscriptionClimate?: Maybe<SubscriptionClimate>;
  disableSubscriptionJohnDeere?: Maybe<SubscriptionJohnDeere>;
  enableSubscriptionClimate?: Maybe<SubscriptionClimate>;
  enableSubscriptionJohnDeere?: Maybe<SubscriptionJohnDeere>;
  /**  DEPRECATED */
  executePaymentTransaction?: Maybe<PaymentTransaction>;
  executeZonesOperation?: Maybe<VectorAnalysisMap>;
  exportAdm?: Maybe<ExportData>;
  exportCNHFieldToGeoPard?: Maybe<ResponseExportCnhToGeoPard>;
  exportCNHFieldsToGeoPard?: Maybe<ResponseExportCnhToGeoPard>;
  exportCNHOperationToGeoPard?: Maybe<ResponseExportCnhToGeoPard>;
  exportClimateFieldDatasetToGeoPard?: Maybe<ResponseOperationClimate>;
  exportData?: Maybe<ExportData>;
  exportGeoPardFieldToClimateAsFile?: Maybe<ResponseOperationClimate>;
  exportGeoPardFieldsToJohnDeereAsFiles?: Maybe<ResponseOperationJohnDeere>;
  exportGeoPardRxToCNHAsFile?: Maybe<ResponseOperationCnh>;
  exportGeoPardRxToClimateAsFile?: Maybe<ResponseOperationClimate>;
  exportGeoPardYieldDataToClimateAsFile?: Maybe<ResponseOperationClimate>;
  exportIsoXml?: Maybe<ExportData>;
  exportToJohnDeereAsApplicationWorkPlan?: Maybe<ResponseWorkPlanJohnDeere>;
  exportToJohnDeereAsFiles?: Maybe<ResponseOperationJohnDeere>;
  exportToJohnDeereAsMapsLayers?: Maybe<ResponseOperationJohnDeere>;
  exportToJohnDeereAsSeedingWorkPlan?: Maybe<ResponseWorkPlanJohnDeere>;
  extractFileMetaData?: Maybe<ExtractFileMetaData>;
  findPlanetMasks?: Maybe<PlanetAsync>;
  flushProfileAgrirouter?: Maybe<ResponseOperationAgrirouter>;
  flushProfileArcGIS?: Maybe<ResponseOperationArcGis>;
  flushProfileCNH?: Maybe<ResponseOperationCnh>;
  flushProfileClimate?: Maybe<ResponseOperationClimate>;
  flushProfileFarmEngage?: Maybe<ResponseOperationFarmEngage>;
  flushProfileJohnDeere?: Maybe<ResponseOperationJohnDeere>;
  flushProfilePessl?: Maybe<ResponseOperationPessl>;
  generateAsAppliedRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateAsAppliedRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateAsAppliedVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateAsAppliedVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  generateCortevaZonesMapAsyncWithIncludeLogic?: Maybe<CortevaZonesMapAsync>;
  generateEquationMap?: Maybe<EquationMap>;
  generateEquationMapAsync?: Maybe<EquationMapAsync>;
  generateEquationVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateEquationVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  generateMultiLayersRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateMultiLayersRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateMultiLayersVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateMultiLayersVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  /**  DEPRECATED */
  generatePaymentToken?: Maybe<PaymentToken>;
  generatePfeiferLangenNotes?: Maybe<Array<Maybe<Note>>>;
  generatePfeiferLangenZonesMapsAsync?: Maybe<Array<Maybe<VectorAnalysisMapAsync>>>;
  generatePresignedPostFileData?: Maybe<PresignedPostFileData>;
  generatePresignedPostPhotoData?: Maybe<PresignedPostPhotoData>;
  generateRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateReportsAsync?: Maybe<Array<Maybe<ReportAsync>>>;
  generateSoilRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateSoilRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateSoilVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateSoilVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  generateStripeInvoicePreview?: Maybe<StripeInvoicePreview>;
  generateSyntheticYieldDataset: YieldDatasetAsync;
  generateTopographyRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateTopographyRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateTopographyVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateTopographyVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  generateVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  generateVectorAnalysisMapFromRaster?: Maybe<VectorAnalysisMap>;
  generateVectorAnalysisMapFromRasterAsync?: Maybe<VectorAnalysisMapAsync>;
  generateYieldRasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  generateYieldRasterAnalysisMapAsync?: Maybe<RasterAnalysisMapAsync>;
  generateYieldVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  generateYieldVectorAnalysisMapAsync?: Maybe<VectorAnalysisMapAsync>;
  importAllFromJohnDeere?: Maybe<ResponseOperationJohnDeere>;
  importAllFromJohnDeereAsync?: Maybe<ResponseOperationJohnDeere>;
  importFromJohnDeere?: Maybe<ResponseOperationJohnDeere>;
  importFromJohnDeereAsync?: Maybe<ResponseOperationJohnDeere>;
  manageProfileClimate?: Maybe<ManageProfileClimate>;
  manageProfileJohnDeere?: Maybe<ManageProfileJohnDeere>;
  orderPackage?: Maybe<UserOrder>;
  orderPlanetImage?: Maybe<PlanetAsync>;
  refreshVectorAnalysisMapStatistics?: Maybe<Scalars['AWSJSON']['output']>;
  registerField: Field;
  /**  DEPRECATED */
  removeVectorAnalysisMapFromShoppingCart?: Maybe<ShoppingCart>;
  retriggerVectorDatasetUpload?: Maybe<RetriggerVectorDatasetUploadResult>;
  saveAsAppliedDataset: AsAppliedDataset;
  saveColorSchema?: Maybe<ColorSchema>;
  saveEquation?: Maybe<Equation>;
  saveEquationMap?: Maybe<EquationMap>;
  saveFarm: Farm;
  saveField: Field;
  saveGrid?: Maybe<VectorAnalysisMap>;
  saveLabels?: Maybe<Array<Maybe<Label>>>;
  saveNote?: Maybe<Note>;
  saveNotes?: Maybe<Array<Maybe<Note>>>;
  saveOrganization?: Maybe<Organization>;
  saveSoilDataset: SoilDataset;
  saveStripeCustomer?: Maybe<StripeCustomer>;
  saveStripeSubscription?: Maybe<StripeSubscriptionSaveData>;
  saveThreeDimensionalMap: ThreeDimensionalMap;
  saveTopographyDataset: TopographyMap;
  saveTrial?: Maybe<Trial>;
  saveUserBatch?: Maybe<UserBatchSave>;
  saveUserData?: Maybe<UserData>;
  saveUserDetails?: Maybe<UserDetails>;
  saveUserOrder?: Maybe<UserOrder>;
  saveVectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  saveYieldDataset: YieldDataset;
  sendPlatformEvent: PlatformEvent;
  setFieldLabels: Field;
  setGeoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  shareFarm: Farm;
  shareFarms?: Maybe<Array<Maybe<Farm>>>;
  startFreeTrial?: Maybe<StartFreeTrialStatus>;
  trackUserAction?: Maybe<UserAction>;
  verifyEquation?: Maybe<VerifyEquationResult>;
};


export type MutationActivateCortevaPlanetDataArgs = {
  input?: InputMaybe<ActivateCortevaPlanetDataInput>;
};


export type MutationAddColorSchemasArgs = {
  input?: InputMaybe<ColorSchemasInput>;
};


export type MutationAddFieldLabelsArgs = {
  input?: InputMaybe<BulkFieldLabels>;
};


export type MutationAddNoteCommentArgs = {
  input?: InputMaybe<AddNoteCommentInput>;
};


export type MutationAddNoteCommentsArgs = {
  input?: InputMaybe<AddNoteCommentsInput>;
};


export type MutationAddUsersToOrganizationArgs = {
  input?: InputMaybe<BatchUserOrganizationInput>;
};


export type MutationAddVectorAnalysisMapToShoppingCartArgs = {
  input?: InputMaybe<AddVectorAnalysisMapToShoppingCartInput>;
};


export type MutationAssembleCubeArgs = {
  input?: InputMaybe<CubeAssemblyInput>;
};


export type MutationCalibrateYieldDatasetArgs = {
  input?: InputMaybe<CalibrateYieldDatasetInput>;
};


export type MutationChangeUserStatusArgs = {
  input?: InputMaybe<UserStatusInput>;
};


export type MutationCheckCortevaPreBillingPlanetDataArgs = {
  input?: InputMaybe<CheckCortevaPreBillingPlanetDataInput>;
};


export type MutationCompleteSamplingPlanArgs = {
  input?: InputMaybe<CompleteSamplingPlanInput>;
};


export type MutationConfirmFileUploadArgs = {
  input?: InputMaybe<ConfirmFileUploadInput>;
};


export type MutationCreateFarmArgs = {
  input?: InputMaybe<CreateFarmInput>;
};


export type MutationCreateFieldOperationSubscriptionJohnDeereArgs = {
  input?: InputMaybe<CreateFieldOperationSubscriptionJohnDeereInput>;
};


export type MutationCreateHarvestPlantingApplicationSubscriptionClimateArgs = {
  input?: InputMaybe<CreateHarvestPlantingApplicationSubscriptionClimateInput>;
};


export type MutationCreateOperationSubscriptionCnhArgs = {
  input?: InputMaybe<CreateOperationSubscriptionCnhInput>;
};


export type MutationCreateSamplingPlanArgs = {
  input?: InputMaybe<SamplingPlanInput>;
};


export type MutationDeleteAsAppliedDatasetArgs = {
  input?: InputMaybe<DeleteAsAppliedDatasetInput>;
};


export type MutationDeleteColorSchemasArgs = {
  input?: InputMaybe<ColorSchemasInput>;
};


export type MutationDeleteEquationArgs = {
  input?: InputMaybe<DeleteEquationInput>;
};


export type MutationDeleteEquationMapArgs = {
  input?: InputMaybe<DeleteEquationMapInput>;
};


export type MutationDeleteFarmArgs = {
  input?: InputMaybe<DeleteFarmInput>;
};


export type MutationDeleteFarmsArgs = {
  input?: InputMaybe<BatchDeleteFarmInput>;
};


export type MutationDeleteFieldArgs = {
  input?: InputMaybe<DeleteFieldInput>;
};


export type MutationDeleteFieldLabelsArgs = {
  input?: InputMaybe<BulkFieldLabels>;
};


export type MutationDeleteFieldsArgs = {
  fields?: InputMaybe<Array<InputMaybe<DeleteFieldInput>>>;
};


export type MutationDeleteLabelArgs = {
  input?: InputMaybe<LabelInput>;
};


export type MutationDeleteNoteArgs = {
  input?: InputMaybe<DeleteNoteInput>;
};


export type MutationDeleteNotesArgs = {
  input?: InputMaybe<DeleteNotesInput>;
};


export type MutationDeletePhotoArgs = {
  input?: InputMaybe<DeletePhotoInput>;
};


export type MutationDeletePhotosArgs = {
  input?: InputMaybe<DeletePhotosInput>;
};


export type MutationDeleteRasterAnalysisMapArgs = {
  input?: InputMaybe<DeleteRasterAnalysisMapInput>;
};


export type MutationDeleteSamplingPlansArgs = {
  input?: InputMaybe<Array<InputMaybe<DeleteSamplingPlanInput>>>;
};


export type MutationDeleteSoilDatasetArgs = {
  input?: InputMaybe<DeleteSoilDatasetInput>;
};


export type MutationDeleteSubscriptionCnhArgs = {
  input?: InputMaybe<DeleteSubscriptionCnhInput>;
};


export type MutationDeleteSubscriptionClimateArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionClimateInput>;
};


export type MutationDeleteSubscriptionJohnDeereArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionJohnDeereInput>;
};


export type MutationDeleteThreeDimensionalMapArgs = {
  input?: InputMaybe<DeleteThreeDimensionalMapInput>;
};


export type MutationDeleteTopographyDatasetArgs = {
  input?: InputMaybe<DeleteTopographyDatasetInput>;
};


export type MutationDeleteTrialArgs = {
  input?: InputMaybe<DeleteTrialInput>;
};


export type MutationDeleteUserBatchArgs = {
  input?: InputMaybe<DeleteUserBatchInput>;
};


export type MutationDeleteUsersFromOrganizationArgs = {
  input?: InputMaybe<BatchUserOrganizationInput>;
};


export type MutationDeleteVectorAnalysisMapArgs = {
  input?: InputMaybe<DeleteVectorAnalysisMapInput>;
};


export type MutationDeleteYieldDatasetArgs = {
  input?: InputMaybe<DeleteYieldDatasetInput>;
};


export type MutationDisableSubscriptionClimateArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionClimateInput>;
};


export type MutationDisableSubscriptionJohnDeereArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionJohnDeereInput>;
};


export type MutationEnableSubscriptionClimateArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionClimateInput>;
};


export type MutationEnableSubscriptionJohnDeereArgs = {
  input?: InputMaybe<UpdateStatusSubscriptionJohnDeereInput>;
};


export type MutationExecutePaymentTransactionArgs = {
  input?: InputMaybe<ExecutePaymentTransactionInput>;
};


export type MutationExecuteZonesOperationArgs = {
  input?: InputMaybe<ExecuteZonesOperationInput>;
};


export type MutationExportAdmArgs = {
  input?: InputMaybe<ExportToJohnDeereAsAdmInput>;
};


export type MutationExportCnhFieldToGeoPardArgs = {
  input?: InputMaybe<ExportCnhFieldToGeoPardInput>;
};


export type MutationExportCnhFieldsToGeoPardArgs = {
  input?: InputMaybe<ExportCnhFieldsToGeoPardInput>;
};


export type MutationExportCnhOperationToGeoPardArgs = {
  input?: InputMaybe<ExportCnhOperationToGeoPardInput>;
};


export type MutationExportClimateFieldDatasetToGeoPardArgs = {
  input?: InputMaybe<ExportClimateFieldDatasetToGeoPardInput>;
};


export type MutationExportDataArgs = {
  input?: InputMaybe<ExportDataInput>;
};


export type MutationExportGeoPardFieldToClimateAsFileArgs = {
  input?: InputMaybe<ExportGeoPardFieldToClimateAsFileInput>;
};


export type MutationExportGeoPardFieldsToJohnDeereAsFilesArgs = {
  input?: InputMaybe<ExportGeoPardFieldsToJohnDeereAsFilesInput>;
};


export type MutationExportGeoPardRxToCnhAsFileArgs = {
  input?: InputMaybe<ExportGeoPardRxToCnhAsFileInput>;
};


export type MutationExportGeoPardRxToClimateAsFileArgs = {
  input?: InputMaybe<ExportGeoPardRxToClimateAsFileInput>;
};


export type MutationExportGeoPardYieldDataToClimateAsFileArgs = {
  input?: InputMaybe<ExportGeoPardYieldDataToClimateAsFileInput>;
};


export type MutationExportIsoXmlArgs = {
  input?: InputMaybe<ExportIsoXmlInput>;
};


export type MutationExportToJohnDeereAsApplicationWorkPlanArgs = {
  input?: InputMaybe<ExportToJohnDeereAsApplicationWorkPlanInput>;
};


export type MutationExportToJohnDeereAsFilesArgs = {
  input?: InputMaybe<ExportToJohnDeereAsFilesInput>;
};


export type MutationExportToJohnDeereAsMapsLayersArgs = {
  input?: InputMaybe<ExportToJohnDeereAsMapsLayersInput>;
};


export type MutationExportToJohnDeereAsSeedingWorkPlanArgs = {
  input?: InputMaybe<ExportToJohnDeereAsSeedingWorkPlanInput>;
};


export type MutationExtractFileMetaDataArgs = {
  input?: InputMaybe<ExtractFileMetaDataInput>;
};


export type MutationFindPlanetMasksArgs = {
  input?: InputMaybe<FindPlanetMasksInput>;
};


export type MutationFlushProfileClimateArgs = {
  input?: InputMaybe<FlushProfileClimateInput>;
};


export type MutationGenerateAsAppliedRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateAsAppliedRasterAnalysisMapInput>;
};


export type MutationGenerateAsAppliedRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateAsAppliedRasterAnalysisMapInput>;
};


export type MutationGenerateAsAppliedVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateAsAppliedVectorAnalysisMapInput>;
};


export type MutationGenerateAsAppliedVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateAsAppliedVectorAnalysisMapInput>;
};


export type MutationGenerateCortevaZonesMapAsyncWithIncludeLogicArgs = {
  input?: InputMaybe<GenerateCortevaZonesMapAsyncWithIncludeLogicInput>;
};


export type MutationGenerateEquationMapArgs = {
  input?: InputMaybe<GenerateEquationMapInput>;
};


export type MutationGenerateEquationMapAsyncArgs = {
  input?: InputMaybe<GenerateEquationMapInput>;
};


export type MutationGenerateEquationVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateEquationVectorAnalysisMapInput>;
};


export type MutationGenerateEquationVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateEquationVectorAnalysisMapInput>;
};


export type MutationGenerateMultiLayersRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateMultiLayersRasterAnalysisMapInput>;
};


export type MutationGenerateMultiLayersRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateMultiLayersRasterAnalysisMapInput>;
};


export type MutationGenerateMultiLayersVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateMultiLayersVectorAnalysisMapInput>;
};


export type MutationGenerateMultiLayersVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateMultiLayersVectorAnalysisMapInput>;
};


export type MutationGeneratePfeiferLangenNotesArgs = {
  input?: InputMaybe<GeneratePfeiferLangenVectorAnalysisMapsInput>;
};


export type MutationGeneratePfeiferLangenZonesMapsAsyncArgs = {
  input?: InputMaybe<GeneratePfeiferLangenVectorAnalysisMapsInput>;
};


export type MutationGeneratePresignedPostFileDataArgs = {
  input?: InputMaybe<GeneratePresignedPostFileDataInput>;
};


export type MutationGeneratePresignedPostPhotoDataArgs = {
  input?: InputMaybe<GeneratePresignedPostPhotoDataInput>;
};


export type MutationGenerateRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateRasterAnalysisMapInput>;
};


export type MutationGenerateRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateRasterAnalysisMapInput>;
};


export type MutationGenerateReportsAsyncArgs = {
  input?: InputMaybe<GenerateReportsInput>;
};


export type MutationGenerateSoilRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateSoilRasterAnalysisMapInput>;
};


export type MutationGenerateSoilRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateSoilRasterAnalysisMapInput>;
};


export type MutationGenerateSoilVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateSoilVectorAnalysisMapInput>;
};


export type MutationGenerateSoilVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateSoilVectorAnalysisMapInput>;
};


export type MutationGenerateStripeInvoicePreviewArgs = {
  input?: InputMaybe<GenerateStripeInvoicePreviewInput>;
};


export type MutationGenerateSyntheticYieldDatasetArgs = {
  input?: InputMaybe<GenerateSyntheticYieldDatasetInput>;
};


export type MutationGenerateTopographyRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateTopographyRasterAnalysisMapInput>;
};


export type MutationGenerateTopographyRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateTopographyRasterAnalysisMapInput>;
};


export type MutationGenerateTopographyVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateTopographyVectorAnalysisMapInput>;
};


export type MutationGenerateTopographyVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateTopographyVectorAnalysisMapInput>;
};


export type MutationGenerateVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateVectorAnalysisMapInput>;
};


export type MutationGenerateVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateVectorAnalysisMapInput>;
};


export type MutationGenerateVectorAnalysisMapFromRasterArgs = {
  input?: InputMaybe<GenerateVectorAnalysisMapFromRasterInput>;
};


export type MutationGenerateVectorAnalysisMapFromRasterAsyncArgs = {
  input?: InputMaybe<GenerateVectorAnalysisMapFromRasterInput>;
};


export type MutationGenerateYieldRasterAnalysisMapArgs = {
  input?: InputMaybe<GenerateYieldRasterAnalysisMapInput>;
};


export type MutationGenerateYieldRasterAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateYieldRasterAnalysisMapInput>;
};


export type MutationGenerateYieldVectorAnalysisMapArgs = {
  input?: InputMaybe<GenerateYieldVectorAnalysisMapInput>;
};


export type MutationGenerateYieldVectorAnalysisMapAsyncArgs = {
  input?: InputMaybe<GenerateYieldVectorAnalysisMapInput>;
};


export type MutationImportAllFromJohnDeereArgs = {
  input?: InputMaybe<ImportAllFromJohnDeereInput>;
};


export type MutationImportAllFromJohnDeereAsyncArgs = {
  input?: InputMaybe<ImportAllFromJohnDeereInput>;
};


export type MutationImportFromJohnDeereArgs = {
  input?: InputMaybe<ImportFromJohnDeereInput>;
};


export type MutationImportFromJohnDeereAsyncArgs = {
  input?: InputMaybe<ImportFromJohnDeereInput>;
};


export type MutationManageProfileClimateArgs = {
  input?: InputMaybe<ManageProfileClimateInput>;
};


export type MutationManageProfileJohnDeereArgs = {
  input?: InputMaybe<ManageProfileJohnDeereInput>;
};


export type MutationOrderPackageArgs = {
  input?: InputMaybe<OrderPackageInput>;
};


export type MutationOrderPlanetImageArgs = {
  input?: InputMaybe<OrderPlanetImageInput>;
};


export type MutationRefreshVectorAnalysisMapStatisticsArgs = {
  input?: InputMaybe<RefreshVectorAnalysisMapInput>;
};


export type MutationRegisterFieldArgs = {
  input?: InputMaybe<RegisterFieldInput>;
};


export type MutationRemoveVectorAnalysisMapFromShoppingCartArgs = {
  input?: InputMaybe<RemoveVectorAnalysisMapFromShoppingCartInput>;
};


export type MutationRetriggerVectorDatasetUploadArgs = {
  input?: InputMaybe<RetriggerVectorDatasetUploadInput>;
};


export type MutationSaveAsAppliedDatasetArgs = {
  input?: InputMaybe<SaveAsAppliedDatasetInput>;
};


export type MutationSaveColorSchemaArgs = {
  input?: InputMaybe<ColorSchemaInput>;
};


export type MutationSaveEquationArgs = {
  input?: InputMaybe<SaveEquationInput>;
};


export type MutationSaveEquationMapArgs = {
  input?: InputMaybe<SaveEquationMapInput>;
};


export type MutationSaveFarmArgs = {
  input?: InputMaybe<SaveFarmInput>;
};


export type MutationSaveFieldArgs = {
  input?: InputMaybe<SaveFieldInput>;
};


export type MutationSaveGridArgs = {
  input?: InputMaybe<SaveGridInput>;
};


export type MutationSaveLabelsArgs = {
  input?: InputMaybe<SaveLabelsInput>;
};


export type MutationSaveNoteArgs = {
  input?: InputMaybe<SaveNoteInput>;
};


export type MutationSaveNotesArgs = {
  input?: InputMaybe<SaveNotesInput>;
};


export type MutationSaveOrganizationArgs = {
  input?: InputMaybe<OrganizationInput>;
};


export type MutationSaveSoilDatasetArgs = {
  input?: InputMaybe<SaveSoilDatasetInput>;
};


export type MutationSaveStripeCustomerArgs = {
  input?: InputMaybe<SaveStripeCustomerInput>;
};


export type MutationSaveStripeSubscriptionArgs = {
  input?: InputMaybe<SaveStripeSubscriptionInput>;
};


export type MutationSaveThreeDimensionalMapArgs = {
  input?: InputMaybe<SaveThreeDimensionalMapInput>;
};


export type MutationSaveTopographyDatasetArgs = {
  input?: InputMaybe<SaveTopographyDatasetInput>;
};


export type MutationSaveTrialArgs = {
  input?: InputMaybe<SaveTrialInput>;
};


export type MutationSaveUserBatchArgs = {
  input?: InputMaybe<SaveUserBatchInput>;
};


export type MutationSaveUserDataArgs = {
  input?: InputMaybe<SaveUserDataInput>;
};


export type MutationSaveUserDetailsArgs = {
  input?: InputMaybe<SaveUserDetailsInput>;
};


export type MutationSaveUserOrderArgs = {
  input?: InputMaybe<SaveUserOrderInput>;
};


export type MutationSaveVectorAnalysisMapArgs = {
  input?: InputMaybe<SaveVectorAnalysisMapInput>;
};


export type MutationSaveYieldDatasetArgs = {
  input?: InputMaybe<SaveYieldDatasetInput>;
};


export type MutationSendPlatformEventArgs = {
  input?: InputMaybe<SendPlatformEventInput>;
};


export type MutationSetFieldLabelsArgs = {
  input?: InputMaybe<FieldLabels>;
};


export type MutationSetGeoMapsArgs = {
  input?: InputMaybe<SetGeoMapsInput>;
};


export type MutationShareFarmArgs = {
  input?: InputMaybe<ShareFarmInput>;
};


export type MutationShareFarmsArgs = {
  input?: InputMaybe<BatchShareFarmInput>;
};


export type MutationStartFreeTrialArgs = {
  input?: InputMaybe<StartFreeTrialInput>;
};


export type MutationTrackUserActionArgs = {
  input?: InputMaybe<UserActionInput>;
};


export type MutationVerifyEquationArgs = {
  input?: InputMaybe<VerifyEquationInput>;
};

export type Note = {
  __typename?: 'Note';
  /**   specific Sampling Plan data */
  alternativeUuid?: Maybe<Scalars['ID']['output']>;
  centroid?: Maybe<Centroid>;
  comment?: Maybe<Scalars['String']['output']>;
  /**  used as description */
  comments?: Maybe<Array<Maybe<Comment>>>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  fieldUuid: Scalars['ID']['output'];
  isEndPoint?: Maybe<Scalars['Boolean']['output']>;
  isStartPoint?: Maybe<Scalars['Boolean']['output']>;
  pathId?: Maybe<Scalars['Int']['output']>;
  photos?: Maybe<Array<Maybe<Photo>>>;
  sampleDepth?: Maybe<Scalars['Float']['output']>;
  samplingPlanUuid?: Maybe<Scalars['ID']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  soilDataset?: Maybe<SoilDataset>;
  templateParameters?: Maybe<Array<Maybe<SamplingPlanTemplateParameter>>>;
  title?: Maybe<Scalars['String']['output']>;
  type: NoteType;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  vectorAnalysisMap?: Maybe<VectorAnalysisMap>;
  zoneId?: Maybe<Scalars['Int']['output']>;
};

export enum NoteType {
  Planned = 'PLANNED',
  Real = 'REAL'
}

export type OperationCnh = {
  __typename?: 'OperationCNH';
  crop: Scalars['String']['output'];
  cropSeason: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fileFormat: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operationType: Scalars['String']['output'];
};

export type OperationFilterCnh = {
  companyId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum OperationType {
  Application = 'Application',
  Compaction = 'Compaction',
  Harvest = 'Harvest',
  Seeding = 'Seeding',
  SoilSampling = 'SoilSampling',
  Tillage = 'Tillage',
  Unknown = 'Unknown'
}

export type OrderPackageInput = {
  uuid: Scalars['ID']['input'];
};

export type OrderPlanetImageInput = {
  fieldUuid: Scalars['ID']['input'];
  satelliteImageUuid: Scalars['ID']['input'];
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  InvoicePaid = 'INVOICE_PAID',
  InvoiceSent = 'INVOICE_SENT',
  PackageOrdered = 'PACKAGE_ORDERED'
}

export type Organization = {
  __typename?: 'Organization';
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerUuid?: Maybe<Scalars['ID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  users?: Maybe<Array<Maybe<UserOrganization>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationFarmEngage = {
  __typename?: 'OrganizationFarmEngage';
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMetric?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  timezoneName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationFilterJohnDeere = {
  orgName?: InputMaybe<Scalars['String']['input']>;
  organizationsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationJohnDeere = {
  __typename?: 'OrganizationJohnDeere';
  fields?: Maybe<Array<Maybe<FieldJohnDeere>>>;
  id: Scalars['ID']['output'];
  links: Array<Maybe<LinkOrganizationJohnDeere>>;
  name: Scalars['String']['output'];
};


export type OrganizationJohnDeereFieldsArgs = {
  fieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type OrganizationsFarmEngage = {
  __typename?: 'OrganizationsFarmEngage';
  orgs?: Maybe<Array<Maybe<OrganizationFarmEngage>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type PaginationActivityTypeCnh = {
  __typename?: 'PaginationActivityTypeCNH';
  activityTypes?: Maybe<Array<Maybe<ActivityTypeCnh>>>;
  pagination?: Maybe<PaginationCnh>;
};

export type PaginationAsAppliedDataset = {
  __typename?: 'PaginationAsAppliedDataset';
  asAppliedDatasets?: Maybe<Array<Maybe<AsAppliedDataset>>>;
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationBoundaryInfoCnh = {
  __typename?: 'PaginationBoundaryInfoCNH';
  boundaries?: Maybe<Array<Maybe<BoundaryInfoCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationCnh = {
  __typename?: 'PaginationCNH';
  pageNumber?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
  totalPageCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationChemicalCnh = {
  __typename?: 'PaginationChemicalCNH';
  chemicals?: Maybe<Array<Maybe<ChemicalCnh>>>;
  pagination?: Maybe<PaginationCnh>;
};

export type PaginationChemicalJohnDeere = {
  __typename?: 'PaginationChemicalJohnDeere';
  chemicals?: Maybe<Array<Maybe<WeightedProductJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationCompanyCnh = {
  __typename?: 'PaginationCompanyCNH';
  companies?: Maybe<Array<Maybe<CompanyCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationDryBlendJohnDeere = {
  __typename?: 'PaginationDryBlendJohnDeere';
  dryBlends?: Maybe<Array<Maybe<DryBlendJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationEquation = {
  __typename?: 'PaginationEquation';
  equations?: Maybe<Array<Maybe<Equation>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginationEquipmentCnh = {
  __typename?: 'PaginationEquipmentCNH';
  equipments?: Maybe<Array<Maybe<EquipmentCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationFarm = {
  __typename?: 'PaginationFarm';
  farms?: Maybe<Array<Maybe<Farm>>>;
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationFarmCnh = {
  __typename?: 'PaginationFarmCNH';
  farms?: Maybe<Array<Maybe<FarmCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationFertilizerCnh = {
  __typename?: 'PaginationFertilizerCNH';
  fertilizers?: Maybe<Array<Maybe<FertilizerCnh>>>;
  pagination?: Maybe<PaginationCnh>;
};

export type PaginationFertilizerJohnDeere = {
  __typename?: 'PaginationFertilizerJohnDeere';
  fertilizers?: Maybe<Array<Maybe<WeightedProductJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationField = {
  __typename?: 'PaginationField';
  fields?: Maybe<Array<Maybe<Field>>>;
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationFieldCnh = {
  __typename?: 'PaginationFieldCNH';
  fields?: Maybe<Array<Maybe<FieldCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationFieldJohnDeere = {
  __typename?: 'PaginationFieldJohnDeere';
  fields?: Maybe<Array<Maybe<FieldJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationGrowerCnh = {
  __typename?: 'PaginationGrowerCNH';
  growers?: Maybe<Array<Maybe<GrowerCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationGuidanceLinesJohnDeere = {
  __typename?: 'PaginationGuidanceLinesJohnDeere';
  guidanceLines?: Maybe<Array<Maybe<GuidanceLinesJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationNote = {
  __typename?: 'PaginationNote';
  lastEvaluatedKey?: Maybe<Key>;
  notes?: Maybe<Array<Maybe<Note>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationOperationCnh = {
  __typename?: 'PaginationOperationCNH';
  operations?: Maybe<Array<Maybe<OperationCnh>>>;
  pagination?: Maybe<PaginationCnh>;
};

export type PaginationOrganizationJohnDeere = {
  __typename?: 'PaginationOrganizationJohnDeere';
  orgs?: Maybe<Array<Maybe<OrganizationJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationPath = {
  __typename?: 'PaginationPath';
  lastEvaluatedKey?: Maybe<Key>;
  paths?: Maybe<Array<Maybe<Path>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationProductMixeCnh = {
  __typename?: 'PaginationProductMixeCNH';
  pagination?: Maybe<PaginationCnh>;
  productMixes?: Maybe<Array<Maybe<ProductMixeCnh>>>;
};

export type PaginationSamplingPlan = {
  __typename?: 'PaginationSamplingPlan';
  lastEvaluatedKey?: Maybe<Key>;
  plans?: Maybe<Array<Maybe<SamplingPlan>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationSeasonCnh = {
  __typename?: 'PaginationSeasonCNH';
  pagination?: Maybe<PaginationCnh>;
  seasons?: Maybe<Array<Maybe<SeasonCnh>>>;
};

export type PaginationSeedCnh = {
  __typename?: 'PaginationSeedCNH';
  pagination?: Maybe<PaginationCnh>;
  seeds?: Maybe<Array<Maybe<SeedCnh>>>;
};

export type PaginationSoilDataset = {
  __typename?: 'PaginationSoilDataset';
  lastEvaluatedKey?: Maybe<Key>;
  soilDatasets?: Maybe<Array<Maybe<SoilDataset>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationSubscriptionCnh = {
  __typename?: 'PaginationSubscriptionCNH';
  subscriptions?: Maybe<Array<Maybe<SubscriptionCnh>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationSubscriptionClimate = {
  __typename?: 'PaginationSubscriptionClimate';
  subscriptions?: Maybe<Array<Maybe<SubscriptionClimate>>>;
};

export type PaginationSubscriptionJohnDeere = {
  __typename?: 'PaginationSubscriptionJohnDeere';
  subscriptions?: Maybe<Array<Maybe<SubscriptionJohnDeere>>>;
};

export type PaginationTankMixJohnDeere = {
  __typename?: 'PaginationTankMixJohnDeere';
  tankMixes?: Maybe<Array<Maybe<TankMixJohnDeere>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationUnitOfMeasureCnh = {
  __typename?: 'PaginationUnitOfMeasureCNH';
  pagination?: Maybe<PaginationCnh>;
  unitsOfMeasure?: Maybe<Array<Maybe<UnitOfMeasureCnh>>>;
};

export type PaginationUserBatch = {
  __typename?: 'PaginationUserBatch';
  batches?: Maybe<Array<Maybe<UserBatch>>>;
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaginationUserData = {
  __typename?: 'PaginationUserData';
  nextToken?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<UserData>>>;
};

export type PaginationVarietyJohnDeere = {
  __typename?: 'PaginationVarietyJohnDeere';
  totalCount?: Maybe<Scalars['Int']['output']>;
  varieties?: Maybe<Array<Maybe<VarietyJohnDeere>>>;
};

export type PaginationYieldDataset = {
  __typename?: 'PaginationYieldDataset';
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  yieldDatasets?: Maybe<Array<Maybe<YieldDataset>>>;
};

export type PaginationZonesMaps = {
  __typename?: 'PaginationZonesMaps';
  lastEvaluatedKey?: Maybe<Key>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  zonesMaps?: Maybe<Array<Maybe<VectorAnalysisMap>>>;
};

export type Path = {
  __typename?: 'Path';
  asAppliedDataset?: Maybe<AsAppliedDataset>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  equationMap?: Maybe<EquationMap>;
  fieldUuid: Scalars['ID']['output'];
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  lineLength?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerUuid: Scalars['ID']['output'];
  pathUrl?: Maybe<Scalars['String']['output']>;
  samplingPlan?: Maybe<SamplingPlan>;
  soilDataset?: Maybe<SoilDataset>;
  type?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  yieldDataset?: Maybe<YieldDataset>;
};


export type PathGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PathGenerationLogic {
  SmartOptimal = 'SmartOptimal',
  ZoneByZone = 'ZoneByZone'
}

export enum PathType {
  AbLine = 'AB_LINE',
  Other = 'OTHER',
  SamplingPlan = 'SAMPLING_PLAN',
  WateringPipeline = 'WATERING_PIPELINE'
}

export type PathsInput = {
  datasetKey?: InputMaybe<Scalars['String']['input']>;
  /**   Or fetch by field with optional filters */
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /**   Fetch exact paths by their UUIDs (corresponds to InvertedIndex lookup) */
  pathUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PathType>;
};

export enum PaymentMethod {
  PaypalInvoice = 'PAYPAL_INVOICE',
  StripeInvoice = 'STRIPE_INVOICE',
  WireTransferInvoice = 'WIRE_TRANSFER_INVOICE'
}

export type PaymentToken = {
  __typename?: 'PaymentToken';
  token: Scalars['String']['output'];
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Float']['output'];
  createdDate: Scalars['AWSDateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type Pessl = {
  __typename?: 'Pessl';
  acceptUrl?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  hasRefreshToken?: Maybe<Scalars['Boolean']['output']>;
};

export type Photo = {
  __typename?: 'Photo';
  commentUuid?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  noteUuid?: Maybe<Scalars['ID']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum PhotoExtention {
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Png = 'png'
}

export type PlanetArchiveAsync = {
  __typename?: 'PlanetArchiveAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode: Scalars['Int']['output'];
  statusMessage: Scalars['String']['output'];
};

export type PlanetAsync = {
  __typename?: 'PlanetAsync';
  expectedNumberOfImages: Scalars['Int']['output'];
  fieldUuid: Scalars['ID']['output'];
  satelliteImageUuid?: Maybe<Scalars['ID']['output']>;
  statusCode: Scalars['Int']['output'];
  statusMessage: Scalars['String']['output'];
};

export type PlatformContextEvent = {
  __typename?: 'PlatformContextEvent';
  executionDate: Scalars['AWSDateTime']['output'];
  fieldUuid?: Maybe<Scalars['ID']['output']>;
  messageKey?: Maybe<ContextMessageKey>;
  operationId?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContextEventStatus>;
  subFieldType?: Maybe<TreeNodeEntity>;
  subFieldUuid?: Maybe<Scalars['ID']['output']>;
  userUuid: Scalars['ID']['output'];
};

export type PlatformContextEventFilter = {
  dateFrom?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dateTo?: InputMaybe<Scalars['AWSDateTime']['input']>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  operationIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<ContextEventStatus>>>;
  subFieldTypes?: InputMaybe<Array<InputMaybe<TreeNodeEntity>>>;
  subFieldUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PlatformContextEventList = {
  __typename?: 'PlatformContextEventList';
  events?: Maybe<Array<Maybe<PlatformContextEvent>>>;
  queryId?: Maybe<Scalars['String']['output']>;
};

export type PlatformEvent = {
  __typename?: 'PlatformEvent';
  action: PlatformEventAction;
  nodePath: Array<Maybe<TreeNode>>;
  userUuid: Scalars['ID']['output'];
  uuid?: Maybe<Scalars['ID']['output']>;
};

export enum PlatformEventAction {
  Insert = 'INSERT',
  Modify = 'MODIFY',
  Remove = 'REMOVE'
}

export type PlatformEventFilter = {
  dateFrom?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dateTo?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fieldUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  queryId?: InputMaybe<Scalars['String']['input']>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PlatformEventList = {
  __typename?: 'PlatformEventList';
  events?: Maybe<Array<Maybe<PlatformEventWrapper>>>;
  queryId?: Maybe<Scalars['String']['output']>;
};

export type PlatformEventWrapper = {
  __typename?: 'PlatformEventWrapper';
  event: PlatformEvent;
  executionDate: Scalars['AWSDateTime']['output'];
};

export type PreBillingPlanetStatistics = {
  __typename?: 'PreBillingPlanetStatistics';
  corruptedImagesNumber: Scalars['Int']['output'];
  dateFrom: Scalars['AWSDate']['output'];
  dateTo: Scalars['AWSDate']['output'];
  fieldUuid: Scalars['ID']['output'];
  goodImagesNumber: Scalars['Int']['output'];
};

export type PresignedPostFileData = {
  __typename?: 'PresignedPostFileData';
  farmUuid?: Maybe<Scalars['ID']['output']>;
  fileExtension?: Maybe<UploadFileExtension>;
  fileType: UploadFileType;
  ignoreAutoProcessing: Scalars['Boolean']['output'];
  s3Fields: Scalars['AWSJSON']['output'];
  s3Key: Scalars['String']['output'];
  s3Url: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type PresignedPostPhotoData = {
  __typename?: 'PresignedPostPhotoData';
  commentUuid?: Maybe<Scalars['ID']['output']>;
  farmUuid: Scalars['ID']['output'];
  fieldUuid: Scalars['ID']['output'];
  noteUuid: Scalars['ID']['output'];
  s3Fields: Scalars['AWSJSON']['output'];
  s3Url: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export enum PricingPlan {
  AnnualSubscription = 'AnnualSubscription',
  Enterprise = 'ENTERPRISE',
  Expand = 'EXPAND',
  FreeTrial = 'FreeTrial',
  Grow = 'GROW',
  MonthlyPayAsYouGo = 'MonthlyPayAsYouGo',
  Start = 'START',
  Trial = 'TRIAL'
}

export type ProductActivityFilterCnh = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductDryBlendJohnDeere = {
  __typename?: 'ProductDryBlendJohnDeere';
  archived: Scalars['Boolean']['output'];
  carrier: Scalars['Boolean']['output'];
  carrierId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  epaRegistration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materialClassification: Scalars['String']['output'];
  modifiedTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referenceGuid: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  restrictedUse: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ProductFilterCnh = {
  companyId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFilterJohnDeere = {
  orgId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductMixeCnh = {
  __typename?: 'ProductMixeCNH';
  baseSolutionRate: Scalars['String']['output'];
  baseSolutionUOMId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productFormId: Scalars['String']['output'];
};

export enum ProductUnit {
  BuAc = 'BU_AC',
  EurAc = 'EUR_AC',
  EurHa = 'EUR_HA',
  EurM2 = 'EUR_M2',
  GalAc = 'GAL_AC',
  KgAc = 'KG_AC',
  KgHa = 'KG_HA',
  KgM2 = 'KG_M2',
  LbAc = 'LB_AC',
  LAc = 'L_AC',
  LHa = 'L_HA',
  SeedsAc = 'SEEDS_AC',
  SeedsHa = 'SEEDS_HA',
  SeedsM2 = 'SEEDS_M2',
  THa = 'T_HA',
  UsdAc = 'USD_AC',
  UsdHa = 'USD_HA',
  UsdM2 = 'USD_M2'
}

export type Query = {
  __typename?: 'Query';
  getActivityTypesCNH?: Maybe<PaginationActivityTypeCnh>;
  getAsAppliedDatasets?: Maybe<PaginationAsAppliedDataset>;
  getBoundariesCNH?: Maybe<PaginationBoundaryInfoCnh>;
  getBoundaryCNH?: Maybe<BoundaryCnh>;
  getChemicalsCNH?: Maybe<PaginationChemicalCnh>;
  getChemicalsJohnDeere?: Maybe<PaginationChemicalJohnDeere>;
  getCompaniesCNH?: Maybe<PaginationCompanyCnh>;
  getDryBlendsJohnDeere?: Maybe<PaginationDryBlendJohnDeere>;
  getEquations?: Maybe<PaginationEquation>;
  getEquipmentsCNH?: Maybe<PaginationEquipmentCnh>;
  getFarms?: Maybe<Array<Maybe<Farm>>>;
  getFarmsCNH?: Maybe<PaginationFarmCnh>;
  getFertilizersCNH?: Maybe<PaginationFertilizerCnh>;
  getFertilizersJohnDeere?: Maybe<PaginationFertilizerJohnDeere>;
  getFields?: Maybe<PaginationField>;
  getFieldsCNH?: Maybe<PaginationFieldCnh>;
  getFieldsJohnDeere?: Maybe<PaginationFieldJohnDeere>;
  getFieldsOperationsJohnDeere?: Maybe<FieldsWithFieldsOperationsStatisticsJohnDeere>;
  getGrowersCNH?: Maybe<PaginationGrowerCnh>;
  getGuidanceLinesJohnDeere?: Maybe<PaginationGuidanceLinesJohnDeere>;
  getLabelNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getLabels?: Maybe<Array<Maybe<Label>>>;
  getManageConfig?: Maybe<Scalars['AWSJSON']['output']>;
  getNotes?: Maybe<PaginationNote>;
  getOperationsCNH?: Maybe<PaginationOperationCnh>;
  getOrganizationsFarmEngage?: Maybe<OrganizationsFarmEngage>;
  getOrganizationsJohnDeere?: Maybe<PaginationOrganizationJohnDeere>;
  getPaginatedFarms?: Maybe<PaginationFarm>;
  getPaths?: Maybe<PaginationPath>;
  getPlatformContext?: Maybe<PlatformContextEventList>;
  getPlatformEvents?: Maybe<PlatformEventList>;
  getProductMixesCNH?: Maybe<PaginationProductMixeCnh>;
  getProfileAgrirouter?: Maybe<Agrirouter>;
  getProfileArcGIS?: Maybe<ArcGis>;
  getProfileCNH?: Maybe<Cnh>;
  getProfileClimate?: Maybe<Climate>;
  getProfileFarmEngage?: Maybe<FarmEngage>;
  getProfileJohnDeere?: Maybe<JohnDeere>;
  getProfilePessl?: Maybe<Pessl>;
  getSamplingPlans?: Maybe<PaginationSamplingPlan>;
  getSatelliteImageryDataByGeometry?: Maybe<SatelliteImageryDataByGeometry>;
  getSatelliteImageryDataByGeometryBatch?: Maybe<Array<Maybe<SatelliteImageryDataByGeometry>>>;
  getSeasonsCNH?: Maybe<PaginationSeasonCnh>;
  getSeedsCNH?: Maybe<PaginationSeedCnh>;
  /**  DEPRECATED */
  getShoppingCart?: Maybe<ShoppingCart>;
  getSoilDatasets?: Maybe<PaginationSoilDataset>;
  getStripeCustomer?: Maybe<StripeCustomer>;
  getStripePriceOpenDataConfig?: Maybe<Array<Maybe<StripeProductPricingConfig>>>;
  getSubscriptionsCNH?: Maybe<PaginationSubscriptionCnh>;
  getSubscriptionsClimate?: Maybe<PaginationSubscriptionClimate>;
  getSubscriptionsJohnDeere?: Maybe<PaginationSubscriptionJohnDeere>;
  getTankMixesJohnDeere?: Maybe<PaginationTankMixJohnDeere>;
  getTrials?: Maybe<Array<Maybe<Trial>>>;
  getUnitsOfMeasureCNH?: Maybe<PaginationUnitOfMeasureCnh>;
  getUserBatches?: Maybe<PaginationUserBatch>;
  getUserData?: Maybe<UserData>;
  getUsers?: Maybe<PaginationUserData>;
  getVarietiesJohnDeere?: Maybe<PaginationVarietyJohnDeere>;
  getYieldDatasets?: Maybe<PaginationYieldDataset>;
  getZonesMaps?: Maybe<PaginationZonesMaps>;
};


export type QueryGetActivityTypesCnhArgs = {
  filter?: InputMaybe<ProductActivityFilterCnh>;
};


export type QueryGetAsAppliedDatasetsArgs = {
  filter?: InputMaybe<AsAppliedDatasetFilter>;
};


export type QueryGetBoundariesCnhArgs = {
  filter?: InputMaybe<BoundaryInfoFilterCnh>;
};


export type QueryGetBoundaryCnhArgs = {
  filter?: InputMaybe<BoundaryFilterCnh>;
};


export type QueryGetChemicalsCnhArgs = {
  filter?: InputMaybe<ProductFilterCnh>;
};


export type QueryGetChemicalsJohnDeereArgs = {
  chemicalFilter?: InputMaybe<ProductFilterJohnDeere>;
};


export type QueryGetDryBlendsJohnDeereArgs = {
  dryBlendFilter?: InputMaybe<ProductFilterJohnDeere>;
};


export type QueryGetEquationsArgs = {
  filter?: InputMaybe<EquationFilter>;
};


export type QueryGetFarmsArgs = {
  externalKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  farmUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetFarmsCnhArgs = {
  filter?: InputMaybe<FarmFilterCnh>;
};


export type QueryGetFertilizersCnhArgs = {
  filter?: InputMaybe<ProductFilterCnh>;
};


export type QueryGetFertilizersJohnDeereArgs = {
  fertilizerFilter?: InputMaybe<ProductFilterJohnDeere>;
};


export type QueryGetFieldsArgs = {
  filter?: InputMaybe<FieldFilter>;
};


export type QueryGetFieldsCnhArgs = {
  filter?: InputMaybe<FieldFilterCnh>;
};


export type QueryGetFieldsJohnDeereArgs = {
  fieldFilter?: InputMaybe<FieldFilterJohnDeere>;
};


export type QueryGetFieldsOperationsJohnDeereArgs = {
  fieldOperationFilter?: InputMaybe<FieldOperationFilterJohnDeere>;
};


export type QueryGetGrowersCnhArgs = {
  filter?: InputMaybe<GrowerFilterCnh>;
};


export type QueryGetGuidanceLinesJohnDeereArgs = {
  guidanceLinesFilter?: InputMaybe<GuidanceLinesFilterJohnDeere>;
};


export type QueryGetLabelsArgs = {
  input?: InputMaybe<LabelsInput>;
};


export type QueryGetManageConfigArgs = {
  input?: InputMaybe<ManageConfigInput>;
};


export type QueryGetNotesArgs = {
  input?: InputMaybe<FilterNotesInput>;
};


export type QueryGetOperationsCnhArgs = {
  filter?: InputMaybe<OperationFilterCnh>;
};


export type QueryGetOrganizationsJohnDeereArgs = {
  orgFilter?: InputMaybe<OrganizationFilterJohnDeere>;
};


export type QueryGetPaginatedFarmsArgs = {
  filter?: InputMaybe<FarmFilter>;
};


export type QueryGetPathsArgs = {
  input?: InputMaybe<PathsInput>;
};


export type QueryGetPlatformContextArgs = {
  input?: InputMaybe<PlatformContextEventFilter>;
};


export type QueryGetPlatformEventsArgs = {
  input?: InputMaybe<PlatformEventFilter>;
};


export type QueryGetProductMixesCnhArgs = {
  filter?: InputMaybe<ProductFilterCnh>;
};


export type QueryGetSamplingPlansArgs = {
  input?: InputMaybe<SamplingPlanFilterInput>;
};


export type QueryGetSatelliteImageryDataByGeometryArgs = {
  input?: InputMaybe<FetchSatelliteImageryDataByGeometryInput>;
};


export type QueryGetSatelliteImageryDataByGeometryBatchArgs = {
  input?: InputMaybe<Array<InputMaybe<FetchSatelliteImageryDataByGeometryInput>>>;
};


export type QueryGetSeasonsCnhArgs = {
  filter?: InputMaybe<SeasonFilterCnh>;
};


export type QueryGetSeedsCnhArgs = {
  filter?: InputMaybe<ProductFilterCnh>;
};


export type QueryGetSoilDatasetsArgs = {
  filter?: InputMaybe<SoilDatasetFilter>;
};


export type QueryGetStripeCustomerArgs = {
  input?: InputMaybe<GetStripeCustomerInput>;
};


export type QueryGetSubscriptionsCnhArgs = {
  filter?: InputMaybe<SubscriptionFilterCnh>;
};


export type QueryGetTankMixesJohnDeereArgs = {
  tankMixFilter?: InputMaybe<ProductFilterJohnDeere>;
};


export type QueryGetTrialsArgs = {
  input: TrialFilterInput;
};


export type QueryGetUnitsOfMeasureCnhArgs = {
  filter?: InputMaybe<ProductActivityFilterCnh>;
};


export type QueryGetUserBatchesArgs = {
  input?: InputMaybe<FilterUserBatchesInput>;
};


export type QueryGetUsersArgs = {
  filter?: InputMaybe<UserDataFilter>;
};


export type QueryGetVarietiesJohnDeereArgs = {
  varietyFilter?: InputMaybe<ProductFilterJohnDeere>;
};


export type QueryGetYieldDatasetsArgs = {
  filter?: InputMaybe<YieldDatasetFilter>;
};


export type QueryGetZonesMapsArgs = {
  filter?: InputMaybe<ZonesMapsFilter>;
};

export type RasterAnalysisMap = {
  __typename?: 'RasterAnalysisMap';
  asAppliedDataset?: Maybe<AsAppliedDataset>;
  boundingBox: Array<Maybe<Scalars['Float']['output']>>;
  centroid: Centroid;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  fieldUuid: Scalars['ID']['output'];
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<AnalysisParameters>;
  satelliteImages?: Maybe<Array<Maybe<FieldSatelliteImage>>>;
  soilDataset?: Maybe<SoilDataset>;
  status: AnalysisMapStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  topographyMap?: Maybe<TopographyMap>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  yieldDataset?: Maybe<YieldDataset>;
};


export type RasterAnalysisMapGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RasterAnalysisMapAsync = {
  __typename?: 'RasterAnalysisMapAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type RateValueJohnDeere = {
  __typename?: 'RateValueJohnDeere';
  unit: Scalars['String']['output'];
  valueAsDouble: Scalars['String']['output'];
  vrDomainId: Scalars['String']['output'];
};

export type RefreshVectorAnalysisMapInput = {
  areaUnit: AreaUnit;
  fieldUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
  zonesMapGeojson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type RegisterFieldInput = {
  activatedElevationProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  activatedSatimageProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  creationType: FieldCreationType;
  externalKey?: InputMaybe<Scalars['String']['input']>;
  farmUuid: Scalars['ID']['input'];
  geojson: Scalars['AWSJSON']['input'];
  labels?: InputMaybe<Scalars['AWSJSON']['input']>;
  name: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveVectorAnalysisMapFromShoppingCartInput = {
  fieldUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  fieldUuid: Scalars['ID']['output'];
  format?: Maybe<ReportFormat>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ReportAssetInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: TreeNodeEntity;
  uuid: Scalars['ID']['input'];
};

export type ReportAsync = {
  __typename?: 'ReportAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export enum ReportFormat {
  Pdf = 'PDF'
}

export type ResponseExportCnhToGeoPard = {
  __typename?: 'ResponseExportCNHToGeoPard';
  status: Scalars['String']['output'];
};

export type ResponseOperationAgrirouter = {
  __typename?: 'ResponseOperationAgrirouter';
  details?: Maybe<Array<Maybe<DetailResponseOperationAgrirouter>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationArcGis = {
  __typename?: 'ResponseOperationArcGIS';
  details?: Maybe<Array<Maybe<DetailResponseOperationArcGis>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationCnh = {
  __typename?: 'ResponseOperationCNH';
  details?: Maybe<Array<Maybe<DetailResponseOperationCnh>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationClimate = {
  __typename?: 'ResponseOperationClimate';
  details?: Maybe<Array<Maybe<DetailResponseOperationClimate>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationFarmEngage = {
  __typename?: 'ResponseOperationFarmEngage';
  details?: Maybe<Array<Maybe<DetailResponseOperationFarmEngage>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationJohnDeere = {
  __typename?: 'ResponseOperationJohnDeere';
  details?: Maybe<Array<Maybe<DetailResponseOperationJohnDeere>>>;
  status: Scalars['String']['output'];
};

export type ResponseOperationPessl = {
  __typename?: 'ResponseOperationPessl';
  details?: Maybe<Array<Maybe<DetailResponseOperationPessl>>>;
  status: Scalars['String']['output'];
};

export type ResponseWorkPlanJohnDeere = {
  __typename?: 'ResponseWorkPlanJohnDeere';
  details?: Maybe<Array<Maybe<DetailResponseOperationJohnDeere>>>;
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RetriggerVectorDatasetUploadInput = {
  datasetUuid: Scalars['ID']['input'];
  fieldUuid: Scalars['ID']['input'];
  type: AnalysisMapType;
};

export type RetriggerVectorDatasetUploadResult = {
  __typename?: 'RetriggerVectorDatasetUploadResult';
  datasetUuid: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
  fieldUuid: Scalars['ID']['output'];
  s3Path?: Maybe<Scalars['String']['output']>;
  type: AnalysisMapType;
  uploadScheduled: Scalars['Boolean']['output'];
};

export enum SamplingPlacementLogicType {
  Deprecated = 'Deprecated',
  GeopardCoreLineLogic = 'GeopardCoreLineLogic',
  GeopardOptimizedCoverageLogic = 'GeopardOptimizedCoverageLogic',
  NLogic = 'NLogic',
  NzLogic = 'NZLogic',
  SkeletonBased = 'SkeletonBased',
  SmartLogic = 'SmartLogic',
  WLogic = 'WLogic',
  ZLogic = 'ZLogic',
  Backward = 'backward',
  Compatibility = 'compatibility',
  For = 'for',
  Used = 'used'
}

export type SamplingPlan = {
  __typename?: 'SamplingPlan';
  agrochemicalAnalysisType?: Maybe<AgrochemicalAnalysisType>;
  alternativeUuid?: Maybe<Scalars['ID']['output']>;
  analysisDate?: Maybe<Scalars['AWSDateTime']['output']>;
  batchUuid?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  endPoint?: Maybe<Scalars['String']['output']>;
  fieldUuid: Scalars['ID']['output'];
  /**   Grid-based plan fields */
  gridUuid?: Maybe<Scalars['ID']['output']>;
  noteNamePlaceholder?: Maybe<Scalars['String']['output']>;
  noteUuidPlaceholder?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<Note>>>;
  path?: Maybe<Path>;
  pathGenerationLogic?: Maybe<PathGenerationLogic>;
  placementLogicType?: Maybe<SamplingPlacementLogicType>;
  planName?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<SamplingPlanType>;
  planUuidPlaceholder?: Maybe<Scalars['String']['output']>;
  sampleDepth?: Maybe<Scalars['Float']['output']>;
  startPoint?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SamplingPlanStatus>;
  technique?: Maybe<SamplingTechnique>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  /**   Zone-based plan fields */
  vectorAnalysisMapUuid?: Maybe<Scalars['ID']['output']>;
  zoneNamePlaceholder?: Maybe<Scalars['String']['output']>;
  zoneNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zoneNamesTemplateParameters?: Maybe<Array<Maybe<Array<Maybe<SamplingPlanTemplateParameter>>>>>;
  zoneNoteCount?: Maybe<Scalars['Int']['output']>;
  zoneSequence?: Maybe<Scalars['AWSJSON']['output']>;
};

export type SamplingPlanFilterInput = {
  batchUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  noteTypes?: InputMaybe<Array<InputMaybe<NoteType>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  planStatuses?: InputMaybe<Array<InputMaybe<SamplingPlanStatus>>>;
  planTypes?: InputMaybe<Array<InputMaybe<SamplingPlanType>>>;
  planUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vectorAnalysisMapUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type SamplingPlanInput = {
  agrochemicalAnalysisType?: InputMaybe<AgrochemicalAnalysisType>;
  alternativeUuid?: InputMaybe<Scalars['ID']['input']>;
  batchUuid?: InputMaybe<Scalars['ID']['input']>;
  endPoint?: InputMaybe<Scalars['String']['input']>;
  fieldUuid: Scalars['ID']['input'];
  /**   Grid-based plan fields */
  gridUuid?: InputMaybe<Scalars['ID']['input']>;
  isUpdateTrackingInfo?: InputMaybe<Scalars['Boolean']['input']>;
  noteNamePlaceholder?: InputMaybe<Scalars['String']['input']>;
  noteTemplateParameters?: InputMaybe<Array<InputMaybe<SamplingPlanTemplateParameterInput>>>;
  noteUuidPlaceholder?: InputMaybe<Scalars['String']['input']>;
  pathGenerationLogic?: InputMaybe<PathGenerationLogic>;
  placementLogicType?: InputMaybe<SamplingPlacementLogicType>;
  planName?: InputMaybe<Scalars['String']['input']>;
  planType: SamplingPlanType;
  planUuidPlaceholder?: InputMaybe<Scalars['String']['input']>;
  sampleDepth?: InputMaybe<Scalars['Float']['input']>;
  startPoint?: InputMaybe<Scalars['String']['input']>;
  technique?: InputMaybe<SamplingTechnique>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  /**   Zone-based plan fields */
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
  zoneNamePlaceholder?: InputMaybe<Scalars['String']['input']>;
  zoneNoteCount?: InputMaybe<Scalars['Int']['input']>;
  zoneSequence?: InputMaybe<Scalars['AWSJSON']['input']>;
  zoneTemplateParameters?: InputMaybe<Array<InputMaybe<SamplingPlanTemplateParameterInput>>>;
};

export enum SamplingPlanStatus {
  Completed = 'COMPLETED',
  Planned = 'PLANNED'
}

export type SamplingPlanTemplateParameter = {
  __typename?: 'SamplingPlanTemplateParameter';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type SamplingPlanTemplateParameterInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum SamplingPlanType {
  Grid = 'GRID',
  Zone = 'ZONE'
}

export enum SamplingTechnique {
  Composite = 'Composite',
  Core = 'Core'
}

export type SatelliteDataPoint = {
  __typename?: 'SatelliteDataPoint';
  acquisitionDate: Scalars['AWSDateTime']['output'];
  cloudfree: Scalars['Float']['output'];
  provider: SatelliteImageProvider;
  ranges?: Maybe<Array<Maybe<SatelliteImageRangeCoverage>>>;
  uuid: Scalars['ID']['output'];
  value?: Maybe<SatelliteImageIndexStatistics>;
};

export type SatelliteImage = {
  __typename?: 'SatelliteImage';
  acquisitionDate?: Maybe<Scalars['AWSDateTime']['output']>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  provider?: Maybe<SatelliteImageProvider>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
};


export type SatelliteImageGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SatelliteImageIndexRangeCoverage = {
  __typename?: 'SatelliteImageIndexRangeCoverage';
  index: Index;
  ranges: Array<Maybe<SatelliteImageRangeCoverage>>;
};

export type SatelliteImageIndexStatistics = {
  __typename?: 'SatelliteImageIndexStatistics';
  avg?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  mdn?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  std?: Maybe<Scalars['Float']['output']>;
  var?: Maybe<Scalars['Float']['output']>;
};

export enum SatelliteImageProvider {
  L4 = 'L4',
  L5 = 'L5',
  L7 = 'L7',
  L8 = 'L8',
  L9 = 'L9',
  Ps = 'PS',
  S2 = 'S2'
}

export type SatelliteImageRangeCoverage = {
  __typename?: 'SatelliteImageRangeCoverage';
  coverage: Scalars['Float']['output'];
  statistics?: Maybe<SatelliteImageIndexStatistics>;
  value: Array<Scalars['Float']['output']>;
};

export type SatelliteImageRangeInput = {
  index: Index;
  ranges: Array<Array<Scalars['Float']['input']>>;
};

export type SatelliteImageryDataByGeometry = {
  __typename?: 'SatelliteImageryDataByGeometry';
  data: Array<SatelliteDataPoint>;
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  geojson: Scalars['AWSJSON']['output'];
  index?: Maybe<Index>;
  providers?: Maybe<Array<Maybe<SatelliteImageProvider>>>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export enum SatelliteImageryProcessingStatus {
  Failed = 'FAILED',
  None = 'NONE',
  Ordered = 'ORDERED',
  Ready = 'READY'
}

export type SaveAsAppliedDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SaveEquationInput = {
  dataVariables: Array<InputMaybe<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  equationAsText: Scalars['String']['input'];
  equationResultVariable: Scalars['String']['input'];
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  productUnit?: InputMaybe<ProductUnit>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  useNumpy?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveEquationMapInput = {
  equationMapGeojson?: InputMaybe<Scalars['AWSJSON']['input']>;
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<VectorAnalysisMapType>;
  uuid: Scalars['ID']['input'];
};

export type SaveFarmInput = {
  externalKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SaveFieldInput = {
  externalKey?: InputMaybe<Scalars['String']['input']>;
  farmUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SaveGridInput = {
  fieldUuid: Scalars['ID']['input'];
  grid: GridInput;
  name: Scalars['String']['input'];
  type?: InputMaybe<VectorAnalysisMapType>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  zonesMapGeojson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type SaveLabelsInput = {
  labels?: InputMaybe<Array<InputMaybe<LabelInput>>>;
};

export type SaveNoteInput = {
  /**   specific Sampling Plan data */
  alternativeUuid?: InputMaybe<Scalars['ID']['input']>;
  centroid: CentroidInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /**  used as description */
  createdDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  fieldUuid: Scalars['ID']['input'];
  pathId?: InputMaybe<Scalars['Int']['input']>;
  sampleDepth?: InputMaybe<Scalars['Float']['input']>;
  samplingPlanUuid?: InputMaybe<Scalars['ID']['input']>;
  soilDatasetUuid?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: NoteType;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveNotesInput = {
  notes?: InputMaybe<Array<InputMaybe<SaveNoteInput>>>;
};

export type SaveSoilDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SaveStripeCustomerInput = {
  address?: InputMaybe<StripeCustomerAddressInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  taxIdData?: InputMaybe<Array<InputMaybe<StripeTaxIdDataInput>>>;
};

export type SaveStripeSubscriptionInput = {
  areaUnit: AreaUnit;
  customerId: Scalars['ID']['input'];
  items?: InputMaybe<Array<InputMaybe<StripeSubscriptionItemInput>>>;
  plan: StripePlan;
  promocode?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveThreeDimensionalMapInput = {
  dataSourceLayer?: InputMaybe<DataLayerInput>;
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveTopographyDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SaveTrialInput = {
  config: TrialConfigInput;
  fieldUuid: Scalars['ID']['input'];
  geometry?: InputMaybe<Scalars['AWSJSON']['input']>;
  productIndex?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  vectorAnalysisMapUuid: Scalars['ID']['input'];
};

export type SaveUserBatchInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  farmUuids: Array<InputMaybe<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  types: Array<InputMaybe<UserBatchType>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveUserDataInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  areaUnit?: InputMaybe<AreaUnit>;
  companyType?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Country>;
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<UserRegion>;
  soilDatasetClassesAmount?: InputMaybe<Scalars['Int']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaveUserDetailsInput = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  vatId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveUserOrderInput = {
  billingPeriodInMonths: Scalars['Int']['input'];
  currency: Currency;
  orderDate?: InputMaybe<Scalars['AWSDate']['input']>;
  paymentMethod: PaymentMethod;
  plan: PricingPlan;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveVectorAnalysisMapInput = {
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<VectorAnalysisMapType>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  zonesMapGeojson?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type SaveYieldDatasetInput = {
  fieldUuid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type SeasonCnh = {
  __typename?: 'SeasonCNH';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type SeasonFilterCnh = {
  companyId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type SeedCnh = {
  __typename?: 'SeedCNH';
  createdDate: Scalars['String']['output'];
  cropId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SendPlatformEventInput = {
  action: PlatformEventAction;
  nodePath: Array<InputMaybe<TreeNodeInput>>;
  userUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type SetGeoMapsInput = {
  geoMaps?: InputMaybe<Array<InputMaybe<GeoMapInput>>>;
};

export type ShareFarmInput = {
  email: Scalars['String']['input'];
  farmUuid: Scalars['ID']['input'];
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  currency: Currency;
  totalPrice: Scalars['Float']['output'];
  vectorAnalysisMapProducts?: Maybe<Array<Maybe<VectorAnalysisMapProduct>>>;
};

export type SoilDataset = {
  __typename?: 'SoilDataset';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributesUrl?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate: Scalars['AWSDateTime']['output'];
  cropName?: Maybe<Scalars['String']['output']>;
  cropToken?: Maybe<Scalars['String']['output']>;
  fieldCoverage?: Maybe<Scalars['Float']['output']>;
  fieldCoveredArea?: Maybe<Scalars['Float']['output']>;
  fieldUuid: Scalars['ID']['output'];
  fullAttributes?: Maybe<Array<Maybe<FullAttribute>>>;
  geoJsonUrl?: Maybe<Scalars['String']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  geometryType?: Maybe<GeometryType>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  operationFileDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationId?: Maybe<Scalars['String']['output']>;
  operationStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationType?: Maybe<OperationType>;
  originDataUrl?: Maybe<Scalars['String']['output']>;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<DatasetAttributeStatistics>>>;
  status: DatasetStatus;
  totalCoveredArea?: Maybe<Scalars['Float']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  usedMachines?: Maybe<Array<Maybe<Machine>>>;
  uuid: Scalars['ID']['output'];
  /**  DEPRECATED */
  vectorDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  /**  DEPRECATED */
  vectorDataUrl?: Maybe<Scalars['String']['output']>;
};


export type SoilDatasetFieldCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type SoilDatasetGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SoilDatasetOriginDataUrlArgs = {
  format?: InputMaybe<GeoFormat>;
};


export type SoilDatasetSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type SoilDatasetSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};


export type SoilDatasetTotalCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type SoilDatasetFilter = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  soilDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartFreeTrialInput = {
  areaUnit: AreaUnit;
};

export type StartFreeTrialStatus = {
  __typename?: 'StartFreeTrialStatus';
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<StripeCustomerAddress>;
  balance?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invoicePrefix?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<StripeCustomerMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  nextInvoiceSequence?: Maybe<Scalars['Int']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredLocales?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shipping?: Maybe<StripeCustomerShipping>;
  taxExempt?: Maybe<Scalars['String']['output']>;
};

export type StripeCustomerAddress = {
  __typename?: 'StripeCustomerAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type StripeCustomerAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCustomerMetadata = {
  __typename?: 'StripeCustomerMetadata';
  clientReferenceId?: Maybe<Scalars['ID']['output']>;
};

export type StripeCustomerShipping = {
  __typename?: 'StripeCustomerShipping';
  address?: Maybe<StripeCustomerAddress>;
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type StripeDiscount = {
  __typename?: 'StripeDiscount';
  amount?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
};

export type StripeDiscountAmount = {
  __typename?: 'StripeDiscountAmount';
  amount?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
};

export enum StripeIntentType {
  PaymentIntent = 'PaymentIntent',
  SetupIntent = 'SetupIntent'
}

export enum StripeInterval {
  Day = 'day',
  Month = 'month',
  OneTime = 'one_time',
  Week = 'week',
  Year = 'year'
}

export type StripeInvoicePreview = {
  __typename?: 'StripeInvoicePreview';
  created?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  lines?: Maybe<Array<Maybe<StripeLineItem>>>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  subtotalExcludingTax?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalDiscountAmounts?: Maybe<Array<Maybe<StripeDiscount>>>;
  totalExcludingTax?: Maybe<Scalars['Int']['output']>;
  totalTaxAmounts?: Maybe<Array<Maybe<StripeTaxAmount>>>;
};

export type StripeLineItem = {
  __typename?: 'StripeLineItem';
  amount?: Maybe<Scalars['Int']['output']>;
  amountExcludingTax?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountAmounts?: Maybe<Array<Maybe<StripeDiscountAmount>>>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['ID']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  taxAmounts?: Maybe<Array<Maybe<StripeTaxAmount>>>;
};

export enum StripePlan {
  AnnualSubscription = 'AnnualSubscription',
  MonthlyPayAsYouGo = 'MonthlyPayAsYouGo'
}

export type StripePricingConfig = {
  __typename?: 'StripePricingConfig';
  amount?: Maybe<Scalars['Float']['output']>;
  areaUnit?: Maybe<AreaUnit>;
  currency?: Maybe<Currency>;
  interval?: Maybe<StripeInterval>;
  intervalCount?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<StripePlan>;
  price?: Maybe<Scalars['Float']['output']>;
  priceId?: Maybe<Scalars['ID']['output']>;
  triggerSource?: Maybe<StripeTriggerSource>;
  volumePricing?: Maybe<Array<Maybe<StripeVolumePricingConfig>>>;
};

export type StripePricingTier = {
  __typename?: 'StripePricingTier';
  unitAmount?: Maybe<Scalars['Int']['output']>;
  upTo?: Maybe<Scalars['Int']['output']>;
};

export enum StripeProductKey {
  AdditionalUserSeat = 'AdditionalUserSeat',
  BaseMonthlyFee = 'BaseMonthlyFee',
  DatasetImport = 'DatasetImport',
  EquationMapsCreation = 'EquationMapsCreation',
  Export = 'Export',
  FieldRegistration = 'FieldRegistration',
  FieldStorage = 'FieldStorage',
  FullAccessToEssentialFunctionalities = 'FullAccessToEssentialFunctionalities',
  PlanetImagery = 'PlanetImagery',
  SamplingPlanCreation = 'SamplingPlanCreation',
  TrialMapCreation = 'TrialMapCreation',
  YieldCleaningAndCalibration = 'YieldCleaningAndCalibration',
  YieldSyntheticMapCreation = 'YieldSyntheticMapCreation',
  ZonesVraMapsCreation = 'ZonesVRAMapsCreation'
}

export type StripeProductPricingConfig = {
  __typename?: 'StripeProductPricingConfig';
  isDebug?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  prices?: Maybe<Array<Maybe<StripePricingConfig>>>;
  productId?: Maybe<Scalars['ID']['output']>;
  productKey?: Maybe<StripeProductKey>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscriptionItem = {
  __typename?: 'StripeSubscriptionItem';
  currency?: Maybe<Scalars['String']['output']>;
  priceId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  tiers?: Maybe<Array<Maybe<StripePricingTier>>>;
  tiersMode?: Maybe<Scalars['String']['output']>;
  unitAmount?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscriptionItemInput = {
  price?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeSubscriptionSaveData = {
  __typename?: 'StripeSubscriptionSaveData';
  amount: Scalars['Int']['output'];
  clientSecret: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  intentType: StripeIntentType;
  startDate: Scalars['String']['output'];
  subscriptionId: Scalars['ID']['output'];
  subscriptionItems?: Maybe<Array<Maybe<StripeSubscriptionItem>>>;
};

export type StripeTaxAmount = {
  __typename?: 'StripeTaxAmount';
  amount?: Maybe<Scalars['Int']['output']>;
  taxableAmount?: Maybe<Scalars['Int']['output']>;
};

export type StripeTaxIdDataInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum StripeTriggerSource {
  Subscription = 'Subscription',
  User = 'User'
}

export type StripeVolumePricingConfig = {
  __typename?: 'StripeVolumePricingConfig';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  followPlatformEvent?: Maybe<PlatformEvent>;
};


export type SubscriptionFollowPlatformEventArgs = {
  userUuid: Scalars['ID']['input'];
};

export type SubscriptionCnh = {
  __typename?: 'SubscriptionCNH';
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SubscriptionClimate = {
  __typename?: 'SubscriptionClimate';
  active: Scalars['Boolean']['output'];
  dataTypes?: Maybe<Array<Maybe<DataTypeClimate>>>;
  frequency: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  type: SubscriptionTypeClimate;
  users: Array<Maybe<Scalars['String']['output']>>;
};

export type SubscriptionFilterCnh = {
  companyId: Scalars['ID']['input'];
};

export type SubscriptionJohnDeere = {
  __typename?: 'SubscriptionJohnDeere';
  fieldOperationTypes?: Maybe<Array<Maybe<FieldOperationJohnDeereTypes>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgIds: Array<Maybe<Scalars['ID']['output']>>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum SubscriptionTypeClimate {
  HarvestPlantingApplication = 'HARVEST_PLANTING_APPLICATION'
}

export type SynchronizedField = {
  __typename?: 'SynchronizedField';
  createdDate: Scalars['AWSDateTime']['output'];
  farmUuid: Scalars['ID']['output'];
  fieldUuid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusMessage: Scalars['String']['output'];
  updatedDate: Scalars['AWSDateTime']['output'];
};

export type SyntheticYieldDatasetConfig = {
  __typename?: 'SyntheticYieldDatasetConfig';
  crop?: Maybe<CropEnum>;
  harvestStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  harvestYear?: Maybe<Scalars['Int']['output']>;
  yieldAttribute?: Maybe<Scalars['String']['output']>;
  yieldAverage?: Maybe<Scalars['Float']['output']>;
  yieldTotal?: Maybe<Scalars['Float']['output']>;
  yieldUnit?: Maybe<AttributeUnit>;
};

export type TankMixJohnDeere = {
  __typename?: 'TankMixJohnDeere';
  archived: Scalars['Boolean']['output'];
  carrier: CarrierTankMixJohnDeere;
  components?: Maybe<Array<Maybe<ComponentTankMixJohnDeere>>>;
  id: Scalars['ID']['output'];
  materialClassification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  orgUniqueId: Scalars['ID']['output'];
  solutionRate: RateValueJohnDeere;
  targetCrops?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volume: RateValueJohnDeere;
};

export type ThreeDimensionalMap = {
  __typename?: 'ThreeDimensionalMap';
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  dataSourceLayer: DataLayer;
  fieldUuid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  vectorAnalysisMap: VectorAnalysisMap;
};

export enum TopographyAttribute {
  Aspect = 'aspect',
  Dem = 'dem',
  Hillshade = 'hillshade',
  HillshadeCombined = 'hillshade_combined',
  Roughness = 'roughness',
  Slope = 'slope',
  Tpi = 'tpi',
  Tri = 'tri'
}

export type TopographyMap = {
  __typename?: 'TopographyMap';
  attributes?: Maybe<Array<Maybe<TopographyAttribute>>>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate: Scalars['AWSDateTime']['output'];
  fieldUuid: Scalars['ID']['output'];
  fullAttributes?: Maybe<Array<Maybe<FullAttribute>>>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  status: AnalysisMapStatus;
  updatedDate: Scalars['AWSDateTime']['output'];
  uuid: Scalars['ID']['output'];
};


export type TopographyMapGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TopographyMapSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type TopographyMapSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};

export type TreeNode = {
  __typename?: 'TreeNode';
  entity: TreeNodeEntity;
  uuid: Scalars['ID']['output'];
};

export enum TreeNodeEntity {
  AsAppliedDataset = 'AsAppliedDataset',
  Comment = 'Comment',
  Cube = 'Cube',
  Elevation = 'Elevation',
  EquationMap = 'EquationMap',
  Farm = 'Farm',
  Field = 'Field',
  FieldSatelliteImage = 'FieldSatelliteImage',
  JohnDeereField = 'JohnDeereField',
  JohnDeereFile = 'JohnDeereFile',
  JohnDeereMapLayers = 'JohnDeereMapLayers',
  MachineryData = 'MachineryData',
  Note = 'Note',
  Photo = 'Photo',
  Plan = 'Plan',
  PlanetArchive = 'PlanetArchive',
  PlanetImage = 'PlanetImage',
  PlanetMask = 'PlanetMask',
  PlanetSubscription = 'PlanetSubscription',
  RasterAnalysisMap = 'RasterAnalysisMap',
  Report = 'Report',
  SoilDataset = 'SoilDataset',
  ThreeDimensionalMap = 'ThreeDimensionalMap',
  Trial = 'Trial',
  Unknown = 'UNKNOWN',
  VectorAnalysisMap = 'VectorAnalysisMap',
  YieldDataset = 'YieldDataset'
}

export type TreeNodeInput = {
  entity: TreeNodeEntity;
  uuid: Scalars['ID']['input'];
};

/**   Trial Types */
export type Trial = {
  __typename?: 'Trial';
  area?: Maybe<Scalars['Float']['output']>;
  attributesUrl?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  config?: Maybe<TrialConfig>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  epsg?: Maybe<Scalars['Int']['output']>;
  fieldUuid: Scalars['ID']['output'];
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  productIndex?: Maybe<Scalars['Int']['output']>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  vectorAnalysisMapUuid?: Maybe<Scalars['ID']['output']>;
};


/**   Trial Types */
export type TrialAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


/**   Trial Types */
export type TrialGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrialBlock = {
  __typename?: 'TrialBlock';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type TrialBlockInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type TrialConfig = {
  __typename?: 'TrialConfig';
  blocks: Array<Maybe<TrialBlock>>;
  groupBuffer?: Maybe<Scalars['Float']['output']>;
  pattern: TrialPattern;
  plotBuffer: Scalars['Float']['output'];
  plotHeight: Scalars['Float']['output'];
  plotWidth: Scalars['Float']['output'];
  replications: Scalars['Int']['output'];
  treatments: Array<Maybe<TrialTreatment>>;
};

export type TrialConfigInput = {
  blocks: Array<InputMaybe<TrialBlockInput>>;
  groupBuffer?: InputMaybe<Scalars['Float']['input']>;
  pattern: TrialPattern;
  plotBuffer: Scalars['Float']['input'];
  plotHeight: Scalars['Float']['input'];
  plotWidth: Scalars['Float']['input'];
  replications: Scalars['Int']['input'];
  treatments: Array<InputMaybe<TrialTreatmentInput>>;
};

/**   Trial Input Types */
export type TrialFilterInput = {
  fieldUuid: Scalars['ID']['input'];
  trialUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum TrialPattern {
  Checkerboard = 'CHECKERBOARD',
  FieldStrip = 'FIELD_STRIP',
  PlotGrid = 'PLOT_GRID',
  SplitPlot = 'SPLIT_PLOT',
  ZoneStrip = 'ZONE_STRIP'
}

export type TrialTreatment = {
  __typename?: 'TrialTreatment';
  color?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type TrialTreatmentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UnitOfMeasureCnh = {
  __typename?: 'UnitOfMeasureCNH';
  abbreviation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isMetric: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
};

export type UpdateStatusSubscriptionClimateInput = {
  id: Scalars['ID']['input'];
};

export type UpdateStatusSubscriptionJohnDeereInput = {
  id: Scalars['ID']['input'];
};

export enum UploadFileExtension {
  Csv = 'csv',
  Kmz = 'kmz',
  Xlsx = 'xlsx',
  Zip = 'zip'
}

export enum UploadFileType {
  Adapt = 'adapt',
  Applied = 'applied',
  Boundary = 'boundary',
  Soil = 'soil',
  Yield = 'yield'
}

export type UserAction = {
  __typename?: 'UserAction';
  area?: Maybe<Scalars['Float']['output']>;
  creditsAmount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Currency>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  farmUuid?: Maybe<Scalars['ID']['output']>;
  fieldUuid?: Maybe<Scalars['ID']['output']>;
  operation?: Maybe<UserOperationType>;
  operationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  organizationUuid?: Maybe<Scalars['ID']['output']>;
  unitsAmount?: Maybe<Scalars['Float']['output']>;
  userUuid?: Maybe<Scalars['ID']['output']>;
};


export type UserActionAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type UserActionFilter = {
  dateFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  dateTo?: InputMaybe<Scalars['AWSDate']['input']>;
  operation?: InputMaybe<Array<InputMaybe<UserOperationType>>>;
  organizationUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<UserOperationSource>;
  userUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UserActionInput = {
  area?: InputMaybe<Scalars['Float']['input']>;
  areaUnit?: InputMaybe<AreaUnit>;
  details?: InputMaybe<Scalars['AWSJSON']['input']>;
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  operation: UserOperationType;
};

export type UserActionsData = {
  __typename?: 'UserActionsData';
  actions?: Maybe<Array<Maybe<UserAction>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalSum?: Maybe<Scalars['Float']['output']>;
};

export type UserBalance = {
  __typename?: 'UserBalance';
  areaUnit?: Maybe<AreaUnit>;
  creditsAmount: Scalars['Float']['output'];
  currency?: Maybe<Currency>;
  planetImageMaxArea?: Maybe<Scalars['Float']['output']>;
  planetImageUsedArea?: Maybe<Scalars['Float']['output']>;
  unitsAmount?: Maybe<Scalars['String']['output']>;
  userSeatsMax?: Maybe<Scalars['Int']['output']>;
  userSeatsUsed?: Maybe<Scalars['Int']['output']>;
};


export type UserBalancePlanetImageMaxAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type UserBalancePlanetImageUsedAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type UserBalanceFilter = {
  source?: InputMaybe<UserOperationSource>;
};

export type UserBatch = {
  __typename?: 'UserBatch';
  count?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  farmUuid: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerUuid: Scalars['ID']['output'];
  types: Array<Maybe<UserBatchType>>;
  updatedDate: Scalars['AWSDateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type UserBatchFiltersInput = {
  createdFilter?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<UserBatchType>>;
  updatedFilter?: InputMaybe<DateTimeFilterInput>;
};

export type UserBatchSave = {
  __typename?: 'UserBatchSave';
  count?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  farmUuids: Array<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerUuid: Scalars['ID']['output'];
  types: Array<Maybe<UserBatchType>>;
  updatedDate: Scalars['AWSDateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type UserBatchSortCriteriaInput = {
  field: UserBatchSortField;
  order: SortOrder;
};

export enum UserBatchSortField {
  Created = 'created',
  Name = 'name',
  Updated = 'updated'
}

export enum UserBatchType {
  SamplingPlan = 'SAMPLING_PLAN',
  Unknown = 'UNKNOWN'
}

export type UserData = {
  __typename?: 'UserData';
  acceptedTermsAndConditions: Scalars['Boolean']['output'];
  /**  DEPRECATED */
  actions?: Maybe<Array<Maybe<UserAction>>>;
  actionsData?: Maybe<UserActionsData>;
  activatedDefaultYieldCalibration?: Maybe<Scalars['Boolean']['output']>;
  activatedElevationProcessing?: Maybe<Scalars['Boolean']['output']>;
  activatedSatimageProcessing?: Maybe<Scalars['Boolean']['output']>;
  actualCreditsLimit?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  areaUnit?: Maybe<AreaUnit>;
  balance?: Maybe<UserBalance>;
  colorSchemas?: Maybe<Array<Maybe<ColorSchema>>>;
  companyType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  details?: Maybe<UserDetails>;
  email: Scalars['AWSEmail']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  farms?: Maybe<Array<Maybe<Farm>>>;
  identity?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Label>>>;
  language?: Maybe<Language>;
  maxArea: Scalars['Float']['output'];
  /**  DEPRECATED */
  order?: Maybe<UserOrder>;
  orders?: Maybe<Array<Maybe<UserOrder>>>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  packages?: Maybe<Array<Maybe<UserPackage>>>;
  reachedAreaLimit: Scalars['Boolean']['output'];
  /**  DEPRECATED */
  region?: Maybe<UserRegion>;
  soilDatasetClassesAmount?: Maybe<Scalars['Int']['output']>;
  totalArea: Scalars['Float']['output'];
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  /**  DEPRECATED */
  vatNumber?: Maybe<Scalars['String']['output']>;
};


export type UserDataActionsArgs = {
  filter?: InputMaybe<UserActionFilter>;
};


export type UserDataActionsDataArgs = {
  filter?: InputMaybe<UserActionFilter>;
};


export type UserDataBalanceArgs = {
  filter?: InputMaybe<UserBalanceFilter>;
};


export type UserDataFarmsArgs = {
  farmOwnership?: InputMaybe<FarmOwnership>;
};


export type UserDataMaxAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type UserDataTotalAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type UserDataFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  vatId?: Maybe<Scalars['String']['output']>;
};

export enum UserOperationSource {
  Api = 'API',
  Ui = 'UI'
}

export enum UserOperationType {
  AdmExport = 'ADM_EXPORT',
  AsAppliedDataset = 'AS_APPLIED_DATASET',
  AutoFieldPotentialMap = 'AUTO_FIELD_POTENTIAL_MAP',
  BaseMonthlyFee = 'BASE_MONTHLY_FEE',
  CommentPhoto = 'COMMENT_PHOTO',
  CrossLayerZonesMaps = 'CROSS_LAYER_ZONES_MAPS',
  DrawnZonesMaps = 'DRAWN_ZONES_MAPS',
  EquationPixelsMaps = 'EQUATION_PIXELS_MAPS',
  EquationZonesMaps = 'EQUATION_ZONES_MAPS',
  FieldActivation = 'FIELD_ACTIVATION',
  FieldDeletion = 'FIELD_DELETION',
  FieldNote = 'FIELD_NOTE',
  FieldStorage = 'FIELD_STORAGE',
  GeoFeatures = 'GEO_FEATURES',
  GeoMap = 'GEO_MAP',
  GridZoneMap = 'GRID_ZONE_MAP',
  IsoxmlExport = 'ISOXML_EXPORT',
  Map_3D = 'MAP_3D',
  MultiLayerZonesMaps = 'MULTI_LAYER_ZONES_MAPS',
  MultiYearZonesMaps = 'MULTI_YEAR_ZONES_MAPS',
  NoteComment = 'NOTE_COMMENT',
  NotePhoto = 'NOTE_PHOTO',
  PdfReport = 'PDF_REPORT',
  PlanetActivation = 'PLANET_ACTIVATION',
  SamplingPlan = 'SAMPLING_PLAN',
  SentinelLandsatActivation = 'SENTINEL_LANDSAT_ACTIVATION',
  ShpExport = 'SHP_EXPORT',
  SingleLayerZonesMaps = 'SINGLE_LAYER_ZONES_MAPS',
  SinglePlanetImageOrder = 'SINGLE_PLANET_IMAGE_ORDER',
  SoilDataset = 'SOIL_DATASET',
  SoilSensorDataset = 'SOIL_SENSOR_DATASET',
  SourceAsAppliedDataset = 'SOURCE_AS_APPLIED_DATASET',
  SourceFieldSatelliteImage = 'SOURCE_FIELD_SATELLITE_IMAGE',
  SourceSoilDataset = 'SOURCE_SOIL_DATASET',
  SourceTopographyMap = 'SOURCE_TOPOGRAPHY_MAP',
  SourceVectorAnalysisMap = 'SOURCE_VECTOR_ANALYSIS_MAP',
  SourceYieldDataset = 'SOURCE_YIELD_DATASET',
  StabilityZonesMaps = 'STABILITY_ZONES_MAPS',
  TopographyDataset = 'TOPOGRAPHY_DATASET',
  TrialMap = 'TRIAL_MAP',
  UsersAdditionalAccount = 'USERS_ADDITIONAL_ACCOUNT',
  YieldCalibration = 'YIELD_CALIBRATION',
  YieldDataset = 'YIELD_DATASET',
  YieldSynthetic = 'YIELD_SYNTHETIC'
}

export type UserOrder = {
  __typename?: 'UserOrder';
  billingPeriodInMonths?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  orderDate?: Maybe<Scalars['AWSDateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  plan?: Maybe<PricingPlan>;
  referralCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  allFarms?: Maybe<Scalars['Boolean']['output']>;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  farms?: Maybe<Array<Maybe<Farm>>>;
  organizationUuid: Scalars['ID']['output'];
  totalArea: Scalars['Float']['output'];
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  userUuid?: Maybe<Scalars['ID']['output']>;
};


export type UserOrganizationTotalAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type UserPackage = {
  __typename?: 'UserPackage';
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  orderUuid?: Maybe<Scalars['ID']['output']>;
  plan?: Maybe<PricingPlan>;
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum UserRegion {
  Ca = 'CA',
  De = 'DE',
  EuODe = 'EU_O_DE',
  Other = 'OTHER',
  Us = 'US'
}

export type UserStatusInput = {
  enabled: Scalars['Boolean']['input'];
  uuid: Scalars['ID']['input'];
};

export type VarietyJohnDeere = {
  __typename?: 'VarietyJohnDeere';
  archived: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  cropName: Scalars['String']['output'];
  documentsList?: Maybe<Array<Maybe<DocumentJohnDeere>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  referenceGuid: Scalars['String']['output'];
};

export type VectorAnalysisMap = {
  __typename?: 'VectorAnalysisMap';
  analysisType?: Maybe<AnalysisMapType>;
  area: Scalars['Float']['output'];
  asAppliedDataset?: Maybe<AsAppliedDataset>;
  attributesJson?: Maybe<Scalars['AWSJSON']['output']>;
  attributesUrl?: Maybe<Scalars['String']['output']>;
  boundingBox: Array<Maybe<Scalars['Float']['output']>>;
  centroid: Centroid;
  createdDate?: Maybe<Scalars['AWSDateTime']['output']>;
  dataLayers?: Maybe<Array<Maybe<DataLayer>>>;
  equationMap?: Maybe<EquationMap>;
  fieldUuid: Scalars['ID']['output'];
  geoJsonUrl?: Maybe<Scalars['String']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  grid?: Maybe<Grid>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  isPurchased: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numberOfZones?: Maybe<Scalars['Int']['output']>;
  parameters?: Maybe<AnalysisParameters>;
  rasterAnalysisMap?: Maybe<RasterAnalysisMap>;
  satelliteImages?: Maybe<Array<Maybe<FieldSatelliteImage>>>;
  soilDataset?: Maybe<SoilDataset>;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  status: AnalysisMapStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  topographyMap?: Maybe<TopographyMap>;
  type?: Maybe<VectorAnalysisMapType>;
  updatedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  uuid: Scalars['ID']['output'];
  variabilityFactor?: Maybe<Scalars['Float']['output']>;
  yieldDataset?: Maybe<YieldDataset>;
  zonesMapGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  zonesMapUrl?: Maybe<Scalars['String']['output']>;
  zonesOperationMaps?: Maybe<Array<Maybe<ZonesOperationMap>>>;
};


export type VectorAnalysisMapAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type VectorAnalysisMapAttributesJsonArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type VectorAnalysisMapGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VectorAnalysisMapSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type VectorAnalysisMapSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};


export type VectorAnalysisMapZonesMapGeojsonArgs = {
  asMultiGeometry?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<AreaUnit>;
};

export type VectorAnalysisMapAsync = {
  __typename?: 'VectorAnalysisMapAsync';
  fieldUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  /**  DEPRECATED */
  usedImagesNumber?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type VectorAnalysisMapForZonesOperationInput = {
  uuid: Scalars['ID']['input'];
  zoneNumbers: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type VectorAnalysisMapProduct = {
  __typename?: 'VectorAnalysisMapProduct';
  currency: Currency;
  price: Scalars['Float']['output'];
  vectorAnalysisMap?: Maybe<VectorAnalysisMap>;
};

export enum VectorAnalysisMapType {
  Fertilizing = 'FERTILIZING',
  General = 'GENERAL',
  Irrigation = 'IRRIGATION',
  Seeding = 'SEEDING',
  Spraying = 'SPRAYING'
}

export enum VectorAnalysisMapZoneType {
  ZoneId = 'ZONE_ID',
  ZoneValue = 'ZONE_VALUE'
}

export type VerifyEquationInput = {
  dataVariables?: InputMaybe<Array<InputMaybe<DataVariableInput>>>;
  equationAsText?: InputMaybe<Scalars['String']['input']>;
  equationResultVariable: Scalars['String']['input'];
  useNumpy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyEquationResult = {
  __typename?: 'VerifyEquationResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['Float']['output']>;
};

export type WeightedProductJohnDeere = {
  __typename?: 'WeightedProductJohnDeere';
  activeIngredients?: Maybe<Array<Maybe<ActiveIngredientJohnDeere>>>;
  archived: Scalars['Boolean']['output'];
  availableRegistrations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  carrier: Scalars['Boolean']['output'];
  carrierId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  documentsList?: Maybe<Array<Maybe<DocumentJohnDeere>>>;
  id: Scalars['ID']['output'];
  liquidWeight: Scalars['String']['output'];
  materialClassification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  referenceGuid: Scalars['String']['output'];
  registration: Scalars['String']['output'];
  restrictedUse: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  weightUnit: Scalars['String']['output'];
};

export type YieldCalibrateOperation = YieldDatasetOperation & {
  __typename?: 'YieldCalibrateOperation';
  actions?: Maybe<DatasetActions>;
  createdDate: Scalars['AWSDateTime']['output'];
  fieldUuid: Scalars['ID']['output'];
  operationType: UserOperationType;
  userUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type YieldDataset = {
  __typename?: 'YieldDataset';
  appliedCorrections?: Maybe<Array<Maybe<DatasetActionEnum>>>;
  appliedCorrectionsVersion?: Maybe<Scalars['Float']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  boundingBox?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  centroid?: Maybe<Centroid>;
  createdDate: Scalars['AWSDateTime']['output'];
  cropName?: Maybe<Scalars['String']['output']>;
  cropToken?: Maybe<Scalars['String']['output']>;
  fieldCoverage?: Maybe<Scalars['Float']['output']>;
  fieldCoveredArea?: Maybe<Scalars['Float']['output']>;
  fieldUuid: Scalars['ID']['output'];
  fullAttributes?: Maybe<Array<Maybe<FullAttribute>>>;
  generatedWith?: Maybe<Array<YieldDatasetOperation>>;
  geoJsonUrl?: Maybe<Scalars['String']['output']>;
  geoMaps?: Maybe<Array<Maybe<GeoMap>>>;
  geometryType?: Maybe<GeometryType>;
  imageUrlAttributes?: Maybe<Array<Maybe<KeyValue>>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  operationFileDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationId?: Maybe<Scalars['String']['output']>;
  operationStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  operationType?: Maybe<OperationType>;
  originDataUrl?: Maybe<Scalars['String']['output']>;
  sourceDataGeojson?: Maybe<Scalars['AWSJSON']['output']>;
  sourceDataUrl?: Maybe<Scalars['String']['output']>;
  statistics?: Maybe<Array<Maybe<DatasetAttributeStatistics>>>;
  status: DatasetStatus;
  totalCoveredArea?: Maybe<Scalars['Float']['output']>;
  updatedDate: Scalars['AWSDateTime']['output'];
  usedMachines?: Maybe<Array<Maybe<Machine>>>;
  uuid: Scalars['ID']['output'];
};


export type YieldDatasetFieldCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};


export type YieldDatasetGeoMapsArgs = {
  geoMapType?: InputMaybe<GeoMapType>;
  geoMapTypes?: InputMaybe<Array<InputMaybe<GeoMapType>>>;
  isIncludeThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type YieldDatasetOriginDataUrlArgs = {
  format?: InputMaybe<GeoFormat>;
};


export type YieldDatasetSourceDataGeojsonArgs = {
  buffer?: InputMaybe<BufferSize>;
};


export type YieldDatasetSourceDataUrlArgs = {
  buffer?: InputMaybe<BufferSize>;
  format?: InputMaybe<GeoFormat>;
};


export type YieldDatasetTotalCoveredAreaArgs = {
  unit?: InputMaybe<AreaUnit>;
};

export type YieldDatasetAsync = {
  __typename?: 'YieldDatasetAsync';
  fieldUuid: Scalars['ID']['output'];
  originalUuid: Scalars['ID']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type YieldDatasetFilter = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<DatasetStatus>>>;
  yieldDatasetUuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type YieldDatasetOperation = {
  createdDate: Scalars['AWSDateTime']['output'];
  fieldUuid: Scalars['ID']['output'];
  operationType: UserOperationType;
  userUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type YieldSyntheticOperation = YieldDatasetOperation & {
  __typename?: 'YieldSyntheticOperation';
  config?: Maybe<SyntheticYieldDatasetConfig>;
  createdDate: Scalars['AWSDateTime']['output'];
  fieldUuid: Scalars['ID']['output'];
  operationType: UserOperationType;
  userUuid?: Maybe<Scalars['ID']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ZonesMapsFilter = {
  farmUuid?: InputMaybe<Scalars['ID']['input']>;
  fieldUuid?: InputMaybe<Scalars['ID']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastEvaluatedKey?: InputMaybe<KeyInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  purpose?: InputMaybe<VectorAnalysisMapType>;
  type?: InputMaybe<AnalysisMapType>;
  vectorAnalysisMapUuid?: InputMaybe<Scalars['ID']['input']>;
  withRatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZonesOperationMap = {
  __typename?: 'ZonesOperationMap';
  map: VectorAnalysisMap;
  zoneNumbers: Array<Maybe<Scalars['Int']['output']>>;
};

export enum ZonesOperationType {
  Intersect = 'INTERSECT'
}

export type SaveStripeSubscriptionMutationVariables = Exact<{
  input: SaveStripeSubscriptionInput;
}>;


export type SaveStripeSubscriptionMutation = { __typename?: 'Mutation', saveStripeSubscription?: { __typename?: 'StripeSubscriptionSaveData', subscriptionId: string, clientSecret: string, amount: number, startDate: string, endDate: string, subscriptionItems?: Array<{ __typename?: 'StripeSubscriptionItem', priceId: string, quantity?: number | null, tiersMode?: string | null, unitAmount?: number | null, tiers?: Array<{ __typename?: 'StripePricingTier', unitAmount?: number | null, upTo?: number | null } | null> | null } | null> | null } | null };

export type GenerateStripeInvoicePreviewMutationVariables = Exact<{
  input: GenerateStripeInvoicePreviewInput;
}>;


export type GenerateStripeInvoicePreviewMutation = { __typename?: 'Mutation', generateStripeInvoicePreview?: { __typename?: 'StripeInvoicePreview', currency?: Currency | null, subtotal?: number | null, tax?: number | null, total?: number | null, lines?: Array<{ __typename?: 'StripeLineItem', priceId?: string | null, quantity?: number | null, periodStart?: string | null, periodEnd?: string | null, amount?: number | null } | null> | null, totalDiscountAmounts?: Array<{ __typename?: 'StripeDiscount', amount?: number | null } | null> | null } | null };

export type GetManageConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManageConfigQuery = { __typename?: 'Query', getManageConfig?: string | null };

export type GetStripePriceOpenDataConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStripePriceOpenDataConfigQuery = { __typename?: 'Query', getStripePriceOpenDataConfig?: Array<{ __typename?: 'StripeProductPricingConfig', productKey?: StripeProductKey | null, productName?: string | null, productId?: string | null, prices?: Array<{ __typename?: 'StripePricingConfig', priceId?: string | null, amount?: number | null, areaUnit?: AreaUnit | null, currency?: Currency | null, interval?: StripeInterval | null, intervalCount?: number | null, plan?: StripePlan | null, price?: number | null, triggerSource?: StripeTriggerSource | null, volumePricing?: Array<{ __typename?: 'StripeVolumePricingConfig', max?: number | null, min?: number | null, price?: number | null } | null> | null } | null> | null } | null> | null };

export type GetCombinedUserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCombinedUserDataQuery = { __typename?: 'Query', getStripeCustomer?: { __typename?: 'StripeCustomer', id?: string | null, currency?: Currency | null } | null, getUserData?: { __typename?: 'UserData', email: string, uuid: string, country?: Country | null, orders?: Array<{ __typename?: 'UserOrder', plan?: PricingPlan | null, status?: OrderStatus | null } | null> | null } | null };

export type GetOrganizationsUsersQueryVariables = Exact<{
  unit: AreaUnit;
}>;


export type GetOrganizationsUsersQuery = { __typename?: 'Query', getUserData?: { __typename?: 'UserData', organizations?: Array<{ __typename?: 'Organization', uuid?: string | null, ownerUuid?: string | null, users?: Array<{ __typename?: 'UserOrganization', userUuid?: string | null, email?: string | null, totalArea: number } | null> | null } | null> | null } | null };

export type GetUserTotalAreaQueryVariables = Exact<{
  unit: AreaUnit;
}>;


export type GetUserTotalAreaQuery = { __typename?: 'Query', getUserData?: { __typename?: 'UserData', totalArea: number } | null };

export type SaveStripeCustomerMutationVariables = Exact<{
  input: SaveStripeCustomerInput;
}>;


export type SaveStripeCustomerMutation = { __typename?: 'Mutation', saveStripeCustomer?: { __typename?: 'StripeCustomer', id?: string | null } | null };

export type StartFreeTrialMutationVariables = Exact<{
  input: StartFreeTrialInput;
}>;


export type StartFreeTrialMutation = { __typename?: 'Mutation', startFreeTrial?: { __typename?: 'StartFreeTrialStatus', isActive?: boolean | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const SaveStripeSubscriptionDocument = new TypedDocumentString(`
    mutation SaveStripeSubscription($input: SaveStripeSubscriptionInput!) {
  saveStripeSubscription(input: $input) {
    subscriptionId
    clientSecret
    amount
    startDate
    endDate
    subscriptionItems {
      priceId
      quantity
      tiers {
        unitAmount
        upTo
      }
      tiersMode
      unitAmount
    }
  }
}
    `) as unknown as TypedDocumentString<SaveStripeSubscriptionMutation, SaveStripeSubscriptionMutationVariables>;
export const GenerateStripeInvoicePreviewDocument = new TypedDocumentString(`
    mutation GenerateStripeInvoicePreview($input: GenerateStripeInvoicePreviewInput!) {
  generateStripeInvoicePreview(input: $input) {
    lines {
      priceId
      quantity
      periodStart
      periodEnd
      amount
    }
    currency
    subtotal
    tax
    total
    totalDiscountAmounts {
      amount
    }
  }
}
    `) as unknown as TypedDocumentString<GenerateStripeInvoicePreviewMutation, GenerateStripeInvoicePreviewMutationVariables>;
export const GetManageConfigDocument = new TypedDocumentString(`
    query GetManageConfig {
  getManageConfig(input: {configurationProfile: COUNTRY, environment: PROD})
}
    `) as unknown as TypedDocumentString<GetManageConfigQuery, GetManageConfigQueryVariables>;
export const GetStripePriceOpenDataConfigDocument = new TypedDocumentString(`
    query getStripePriceOpenDataConfig {
  getStripePriceOpenDataConfig {
    prices {
      priceId
      amount
      areaUnit
      currency
      interval
      intervalCount
      plan
      price
      triggerSource
      volumePricing {
        max
        min
        price
      }
    }
    productKey
    productName
    productId
  }
}
    `) as unknown as TypedDocumentString<GetStripePriceOpenDataConfigQuery, GetStripePriceOpenDataConfigQueryVariables>;
export const GetCombinedUserDataDocument = new TypedDocumentString(`
    query GetCombinedUserData {
  getStripeCustomer {
    id
    currency
  }
  getUserData {
    email
    uuid
    country
    orders {
      plan
      status
    }
  }
}
    `) as unknown as TypedDocumentString<GetCombinedUserDataQuery, GetCombinedUserDataQueryVariables>;
export const GetOrganizationsUsersDocument = new TypedDocumentString(`
    query GetOrganizationsUsers($unit: AreaUnit!) {
  getUserData {
    organizations {
      uuid
      ownerUuid
      users {
        userUuid
        email
        totalArea(unit: $unit)
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganizationsUsersQuery, GetOrganizationsUsersQueryVariables>;
export const GetUserTotalAreaDocument = new TypedDocumentString(`
    query GetUserTotalArea($unit: AreaUnit!) {
  getUserData {
    totalArea(unit: $unit)
  }
}
    `) as unknown as TypedDocumentString<GetUserTotalAreaQuery, GetUserTotalAreaQueryVariables>;
export const SaveStripeCustomerDocument = new TypedDocumentString(`
    mutation SaveStripeCustomer($input: SaveStripeCustomerInput!) {
  saveStripeCustomer(input: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<SaveStripeCustomerMutation, SaveStripeCustomerMutationVariables>;
export const StartFreeTrialDocument = new TypedDocumentString(`
    mutation StartFreeTrial($input: StartFreeTrialInput!) {
  startFreeTrial(input: $input) {
    isActive
  }
}
    `) as unknown as TypedDocumentString<StartFreeTrialMutation, StartFreeTrialMutationVariables>;